import {
  Checkbox,
  message,
  Select,
  PageHeader,
  Col,
  Row,
  Spin,
  Form as FormInitial,
  Upload,
  Input,
  Popconfirm,
  Alert,
  Table
} from "antd";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { PlusOutlined, UploadOutlined, DeleteOutlined, MobileOutlined, SafetyCertificateOutlined, FilePdfOutlined, EyeOutlined, EditOutlined, TableOutlined, StarFilled, StarOutlined } from "@ant-design/icons";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  SelectEscuelasItem,
  cuentaMask,
  InputItem,
  TextAreaItem,
  ButtonItem,
  SwitchItem,
  ErrorItem,
  calcularSimilitud,
  extraerDatosConstanciaFiscal,
  TabbedDynamicTable,
  DynamicCardForm,
  dineroDisabledMask,
  TableItemDinamico,
} from "../../../../Components/Items";
import ModalInsumoParaCliente from "../../../../Components/ModalInsumoParaCliente";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import SeccionSubirInsumosCliente from "../../../../Components/SeccionSubirInsumosCliente";
import AgregarUnidad from "../../Insumos/AgregarInsumo/AgregarUnidad/AgregarUnidad";
import ModalPrevisualizarArchivos from "../../../../Components/ModalPrevisualizarArchivos";
import FormListLeyendasFiscales from "../../../../Components/FormListLeyendasFiscales";
import ModalUsuarioMovil from "../../../../Components/ModalUsuarioMovil";
import UsuarioEcommerceModal from "./UsuarioEcommerceModal/UsuarioEcommerceModal";
import SelectGruposEscuelaItem from "../../../../Components/SelectGruposEscuelaItem";
import SelectListasEscuelaItem from "../../../../Components/SelectListasEscuelaItem";
import ModalAgregarHermano from "./ModalAgregarHermano/ModalAgregarHermano";
import CambiarTipoEntidadModal from "../../../../Components/CambiarTipoEntidadModal";
import MoverCuentasEntidadModal from "../../../../Components/MoverCuentasEntidadModal";
import ModalEditarPoliza from "../../../../Components/ModalEditarPoliza";
import { getDefaultCamposObligatorios } from "../camposClientesConfig";
import VerLote from "../../Lotes/VerLote/VerLote";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import facturaPdf from "../../../../Pdf/facturaPdf";
import remisionPdf from "../../../../Pdf/remisionPdf";
import pedidoPdf from "../../../../Pdf/pedidoPdf";
import cotizacionPdf from "../../../../Pdf/cotizacionPdf";
import moment from "moment";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
class EditarCliente extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    camposObligatorios: getDefaultCamposObligatorios(),
    todasMonedas: null,
    objetoMonedas: null,
    todasPaises: null,
    objetoPaises: null,
    todasPaisesResidencia: null,    
    objetoPaisesResidencia: null, 
    todasEstados: null,
    objetoEstados: null,
    todasMunicipios: null,
    objetoMunicipios: [],
    todasColonias: null,
    objetoColonias: [],
    todasCuentaContable: null,
    objetoCuentaContable: null,
    todasBancosSat: null,
    objetoBancosSat: null,
    todasTiposDeOperacion: null,
    objetoTiposDeOperacion: null,
    todasTiposDeTerceros: null,
    objetoTiposDeTerceros: null,
    todasTipoDeCliente: null,
    objetoTipoDeCliente: null,
    todasPrecios: null,
    objetoPrecios: null,
    todasUsosDeCFDI: null,
    objetoUsosDeCFDI: null,
    todasProyectos: null,
    objetoProyectos: null,
    todasRegimenFiscal: null,
    objetoRegimenFiscal: null,
    todasRetenciones: null,
    objetoRetenciones: null,
    todasFormasDePago: null,
    objetoFormasDePago: null,
    utilizado: false,
    id: this.props.location.state.id,
    mercanciasEnvio: false,

    // Insumos x Cliente
    insumosPersonalizadosData: [],
    insumosPersonalizadosTotal: 0,
    loadingInsumosPersonalizados: false,
    modalInsumoPersonalizadoVisible: false,
    insumoPersonalizadoEditando: null,
    guardandoInsumoPersonalizado: false,
    guardandoInsumosBulk: false,
    insumoIdsConfigurados: [],
    modalAgregarUnidad: false,
    modalUsuarioMovil: false,
    // Hermanos vinculados (alumnos)
    modalHermano: false,
    todasUnidades: false,
    todasMaterialesPeligrosos: false,
    todasEmbalajes: false,
    unidadPeso: null,
    todasSectoresCOF: false,
    todasFormasFarmaceuticas: false,
    todasCondicionesEspeciales: false,
    todasTiposMaterias: false,
    objetoUnidades: null,
    objetoMaterialesPeligrosos: null,
    objetoEmbalajes: null,
    objetoSectoresCOF: null,
    objetoFormasFarmaceuticas: null,
    objetoCondicionesEspeciales: null,
    objetoTiposMaterias: null,
    objetoCodigosSat: [],
    loadingMercancias: false,
    buscarInfoCodes: [],
    objetoBancos: null,
    objetoPlantasEntrega: null,
    loadingPlantasEntrega: null,
    archivosCliente: [],
    filePreviewVisible: false,
    currentPreviewFile: null,
    maximoArchivos: 3,
    factorajeFinancieroCXC: false,
    complementoComercioExterior: false,
    complementoEmpresaAlterna: false,
    objetoMunicipiosAlterna: null,
    objetoColoniasAlterna: null,
    archivoLogoAlterna: null,
    base64LogoAlterna: null,
    modalUsuarioEcommerceVisible: false,
    historialCargado: false,
    loadingHistorial: false,
    historialVentas: [],
    historialPedidos: [],
    historialCotizaciones: [],
    historialLotes: [],
    pdfGenerandoId: null,
    modalVerLote: false,
    modalVerLoteId: null,
    modalCambiarTipo: false,
    modalMoverCuentas: false,
    polizaReclasificacionId: null,
  };
  atras() {
    this.props.history.goBack();
  }

  // --- Hermanos vinculados (alumnos) ---
  // Recarga solo la lista de hermanos del cliente actual.
  recargarHermanos = async () => {
    try {
      const res = await axios.post(
        "clientes/datosCliente",
        { empresaId: this.props.empresaId, clienteId: this.state.id },
        { headers: this.props.headersToken }
      );
      this.setState((prev) => ({
        dataInicial: {
          ...prev.dataInicial,
          hermanosVinculadosData: res.data.hermanosVinculadosData || [],
        },
      }));
    } catch (e) {
      // noop
    }
  };

  quitarHermano = async (hermanoClienteId) => {
    try {
      const res = await axios.post(
        "clientes/desvincularHermano",
        {
          empresaId: this.props.empresaId,
          clienteId: this.state.id,
          hermanoClienteId,
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        message.success("Hermano desvinculado");
        await this.recargarHermanos();
      } else {
        message.warning(res.data.message || "No se pudo quitar el hermano");
      }
    } catch (e) {
      message.error("Error al quitar el hermano");
    }
  };

  validarDatosClienteSAT() {
    this.setState({ loading: true });
    axios
      .post(
        "clientes/validarDatosClienteSAT",
        { clienteId: this.state.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 1) {
          if (res.data.datosValidos) {
            message.success(res.data.mensaje || "Los datos del receptor son correctos en el SAT", 8);
          } else {
            message.warning(res.data.mensaje || "El nombre del receptor no coincide con el RFC registrado en el SAT", 8);
          }
        } else {
          message.error(res.data.message || "Error al validar datos en el SAT", 8);
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al validar datos en el SAT", 8);
      });
  }

  // --- Historial (Ventas / Pedidos / Cotizaciones / Lotes del cliente) ---
  consultarHistorial() {
    this.setState({ loadingHistorial: true });
    axios
      .post(
        "clientes/historialCliente",
        { clienteId: this.state.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loadingHistorial: false,
            historialCargado: true,
            historialVentas: res.data.ventas || [],
            historialPedidos: res.data.pedidos || [],
            historialCotizaciones: res.data.cotizaciones || [],
            historialLotes: res.data.lotes || [],
          });
        } else {
          this.setState({ loadingHistorial: false });
          message.error(res.data.message || "Error al consultar el historial del cliente");
        }
      })
      .catch(() => {
        this.setState({ loadingHistorial: false });
        message.error("Error al consultar el historial del cliente");
      });
  }

  verPdfVenta(ventaId) {
    this.setState({ pdfGenerandoId: ventaId });
    axios
      .post(
        "ventas/datosPdf",
        { ventaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        const pdf = res.data.factura ? facturaPdf(res.data) : remisionPdf(res.data);
        pdfMake.createPdf(pdf).open();
        this.setState({ pdfGenerandoId: null });
      })
      .catch(() => {
        this.setState({ pdfGenerandoId: null });
        message.error("Error al generar el PDF de la venta");
      });
  }

  verPdfPedido(pedidoId) {
    this.setState({ pdfGenerandoId: pedidoId });
    axios
      .post(
        "pedidos/datosPdf",
        { pedidoId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        pdfMake.createPdf(pedidoPdf(res.data)).open();
        this.setState({ pdfGenerandoId: null });
      })
      .catch(() => {
        this.setState({ pdfGenerandoId: null });
        message.error("Error al generar el PDF del pedido");
      });
  }

  verPdfCotizacion(cotizacionId) {
    this.setState({ pdfGenerandoId: cotizacionId });
    axios
      .post(
        "cotizaciones/datosPdf",
        { cotizacionId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        pdfMake.createPdf(cotizacionPdf(res.data)).open();
        this.setState({ pdfGenerandoId: null });
      })
      .catch(() => {
        this.setState({ pdfGenerandoId: null });
        message.error("Error al generar el PDF de la cotización");
      });
  }

  abrirLote(loteId) {
    this.setState({ modalVerLote: true, modalVerLoteId: loteId });
  }

  cerrarVerLote() {
    this.setState({ modalVerLote: false, modalVerLoteId: null });
  }

  renderHistorialSeccion(titulo, datos, columnas) {
    return (
      <DynamicCardForm
        title={
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {titulo}
            {datos.length > 0 && (
              <span style={{
                background: "#00BFD6",
                color: "white",
                borderRadius: 10,
                padding: "1px 8px",
                fontSize: 11,
                fontWeight: 600,
                lineHeight: "18px",
              }}>
                {datos.length}
              </span>
            )}
          </span>
        }
      >
        <div style={{ fontSize: 12, color: "#999", marginBottom: 8 }}>
          Se muestran máximo los últimos 100 registros.
        </div>
        {datos.length === 0 ? (
          <div style={{ textAlign: "center", padding: "32px 24px", color: "#bbb" }}>
            <p style={{ fontSize: 14, margin: 0 }}>No existen registros todavía</p>
          </div>
        ) : (
          <Table
            rowKey="_id"
            dataSource={datos}
            columns={columnas}
            pagination={{ pageSize: 10 }}
            scroll={{ x: true }}
            size="small"
          />
        )}
      </DynamicCardForm>
    );
  }

  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "clientes/selectDatosParaCliente",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            camposObligatorios: res.data.camposObligatorios || getDefaultCamposObligatorios(),
            todasVendedores: res.data.vendedores,
            todasRetenciones: res.data.retenciones,
            todasRegimenFiscal: res.data.regimenesFiscales,
            todasProyectos: res.data.proyectos,
            todasUsosDeCFDI: res.data.usosDeCFDI,
            todasPrecios: res.data.precios,
            todasBancosSat: res.data.bancosSat,
            todasTipoDeCliente: res.data.tipoDeClientes,
            todasCuentaContable: res.data.cuentasContables,
            todasMonedas: res.data.monedas,
            todasPaises: res.data.paises,
            todasPaisesResidencia: res.data.paisesResidencia,      
            todasEstados: res.data.estados,
            factorajeFinancieroCXC: res.data.factorajeFinancieroCXC,
            complementoComercioExterior: res.data.complementoComercioExterior,
            complementoEmpresaAlterna: res.data.complementoEmpresaAlterna,
            maximoArchivos: res.data.maximoArchivos,
            todasFormasDePago: res.data.formasDePago,
            objetoMonedas: res.data.monedas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
            objetoPaises: res.data.paises.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoPaisesResidencia: res.data.paisesResidencia?.map((value) => {  
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoEstados: res.data.estados.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoCuentaContable: res.data.cuentasContables.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
            objetoTipoDeCliente: res.data.tipoDeClientes.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoBancosSat: res.data.bancosSat.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.clave + " - " + value.nombreCorto}
                </Option>
              );
            }),
            objetoPrecios: res.data.precios.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value?.c_UsoCFDI + ' - ' + value.descripcion}
                </Option>
              );
            }),
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoRegimenFiscal: res.data.regimenesFiscales.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_RegimenFiscal + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoRetenciones: res.data.retenciones.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoVendedores: res.data.vendedores.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre +
                    " " +
                    value.apellidoPaterno +
                    " " +
                    value.apellidoMaterno}
                </Option>
              );
            }),
            objetoCanalesVenta: res.data.canalesVenta?.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.codigo + " - " + value.nombre}
                </Option>
              );
            }),
            objetoBancos: res.data.bancos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoFormasDePago : res.data.formasDePago?.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.descripcion}
                </Option>
              );
            })
          });
        }
      });
    await axios
      .post(
        "clientes/datosCliente",
        { empresaId: this.props.empresaId, clienteId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion del cliente");
        } else {
          if (res.data.utilizado) {
            message.info(
              "No se puede modificar toda la informacion ya que el cliente ya fue utilizado"
            );
          }

          if (res.data.createdAt) {
            const fechaDeAltaFormateada = new Date(res.data.createdAt).toLocaleDateString('es-MX', {
              day: '2-digit', month: '2-digit', year: 'numeric'
            });

            res.data.fechaAlta = fechaDeAltaFormateada;
          }


          if (res.data.tipoClienteId) {
            const tipoDeCliente = this.state.todasTipoDeCliente.find(
              (valueTodos) =>
                valueTodos._id.toString() === res.data.tipoClienteId.toString()
            );
            // Sin el optional chaining, un tipoClienteId que apunta a un tipo
            // borrado o deshabilitado (y que por eso no viene en la lista) tumba
            // la carga completa del formulario.
            if (tipoDeCliente?.generarCuentasAutomatico) {
              this.formRef.current.setFieldsValue({
                ...res.data,
                cuentaClienteId: res.data.cuentaClienteId,
                cuentaAnticipoId: res.data.cuentaAnticipoId,
                cuentaFonGarId: res.data.cuentaFonGarId,
                cuentaDeudorId: res.data.cuentaDeudorId,
              });
            } else {
              this.formRef.current.setFieldsValue({
                ...res.data,
                cuentaClienteId: tipoDeCliente?.cuentaClienteId,
                cuentaAnticipoId: tipoDeCliente?.cuentaAnticipoId,
                cuentaFonGarId: tipoDeCliente?.cuentaFonGarId,
                cuentaDeudorId: tipoDeCliente?.cuentaDeudorId,
              });
            }
          } else {
            this.formRef.current.setFieldsValue({
              ...res.data,
            });
          }

          let base64LogoAlterna = null;
          if (res.data.empresaAlterna?.logo?.base64) {
            const extension = res.data.empresaAlterna.logo.extension;
            const mimetype = extension !== "pdf" ? "image/" + extension : "application/pdf";
            base64LogoAlterna = "data:" + mimetype + ";base64," + res.data.empresaAlterna.logo.base64;
          }

          // Precarga las opciones de Municipio/Colonia de la Empresa Alterna
          // (si ya tenía dirección guardada) sin disparar el reset de campos.
          if (res.data.empresaAlterna?.estadoId) {
            this.onChangeEstadoAlterna(res.data.empresaAlterna.estadoId, true);
          }
          if (res.data.empresaAlterna?.municipioId) {
            this.onChangeMunicipioAlterna(res.data.empresaAlterna.municipioId, true);
          }

          this.setState({
            utilizado: res.data.utilizado,
            mercanciasEnvio: res.data.mercanciasEnvio,
            dataInicial: res.data,
            archivosCliente: res.data.archivos || [],
            usarAdenda: res.data.usarAdenda || false,
            base64LogoAlterna,
          });
        }
      });
    this.setState({ loading: false });
  }
  // Marca una sola cuenta como predeterminada: es la que se propone por default
  // en el complemento de pago al cobrar una venta de este cliente
  marcarCuentaPredeterminada(indice) {
    const cuentas = this.formRef.current.getFieldValue("cuentasBancoCliente") || [];
    const yaEraPredeterminada = !!cuentas[indice]?.predeterminada;
    this.formRef.current.setFieldsValue({
      cuentasBancoCliente: cuentas.map((cuenta, i) => ({
        ...cuenta,
        predeterminada: yaEraPredeterminada ? false : i === indice,
      })),
    });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (values.empresaAlterna?.activo) {
      const ea = values.empresaAlterna;
      const faltaLogo = !this.state.archivoLogoAlterna && !this.state.base64LogoAlterna;
      const faltaAlgo =
        !ea.nombre || !ea.rfc || !ea.paisId || !ea.estadoId ||
        !ea.municipioId || !ea.coloniaId || faltaLogo;
      if (faltaAlgo) {
        message.error(
          "Para activar la Empresa Alterna debes llenar nombre, RFC, dirección completa (país, estado, municipio y colonia) y subir un logo"
        );
        return;
      }
    }

    this.setState({ loading: true });
    const archivosLimpios = this.state.archivosCliente.map(archivo => {

      if (archivo.url && archivo.url.startsWith('data:')) {
        return {
          name: archivo.name,
          url: archivo.url
        };
      }

      if (archivo.cargadoDesdeBackend) {
        return { name: archivo.name, url: archivo.urlRelativa };
      }

      // Fallback por si acaso
      return archivo;
    });

    let empresaAlterna = values.empresaAlterna;
    if (empresaAlterna?.activo && this.state.archivoLogoAlterna) {
      empresaAlterna = {
        ...empresaAlterna,
        logoBase64: this.state.base64LogoAlterna,
        logoName: this.state.archivoLogoAlterna.name,
      };
    }

    axios
      .post(
        "clientes/editarCliente",
        {
          ...values,
          empresaAlterna,
          empresaId: this.props.empresaId,
          clienteId: this.state.id,
          archivos: archivosLimpios,//this.state.archivosCliente,
          // Si se limpia el select, antd lo deja undefined y JSON.stringify tira la clave;
          // sin esto nunca llegaria el "dejar de usar la lista de otro" al backend
          insumosCompartidosDeClienteId: values.insumosCompartidosDeClienteId || null,
          // Igual que arriba: si se quita el canal, que llegue null y se borre
          canalDeVentaId: values.canalDeVentaId || null,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha editado un cliente");
          this.formRef.current.resetFields();
          this.atras();
        } else if (res.data.success === 1) {
          message.warning(
            res.data.message
              ? res.data.message
              : "No se puede editar el cliente"
          );
        } else {
          message.error("Hubo un error y el cliente no se edito");
        }
      });
  }
  onChangeEstado(value, fieldKey, inicial) {
    if (!inicial) {
      let direcciones = this.formRef.current.getFieldValue("direcciones");
      if (typeof direcciones[fieldKey] === "undefined") {
        direcciones[fieldKey] = {};
      }
      direcciones[fieldKey].municipioId = undefined;
      direcciones[fieldKey].coloniaId = undefined;
      this.formRef.current.setFieldsValue({ direcciones: direcciones });
      let objetoColonias = this.state.objetoColonias;
      objetoColonias[fieldKey] = null;
      this.setState({ objetoColonias: objetoColonias });
    }
    axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMunicipios: res.data });
          let objetoMunicipios = this.state.objetoMunicipios;
          objetoMunicipios[fieldKey] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            );
          });
          this.setState({
            objetoMunicipios: objetoMunicipios,
          });
        }
      });
  }
  onChangeMunicipio(value, fieldKey, inicial) {
    if (!inicial) {
      let direcciones = this.formRef.current.getFieldValue("direcciones");
      if (typeof direcciones[fieldKey] === "undefined") {
        direcciones[fieldKey] = {};
      }
      direcciones[fieldKey].coloniaId = undefined;
      this.formRef.current.setFieldsValue({ direcciones: direcciones });
    }

    axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasColonias: res.data });
          let objetoColonias = this.state.objetoColonias;
          objetoColonias[fieldKey] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.cp + " - " + value.nombre}
              </Option>
            );
          });
          this.setState({
            objetoColonias: objetoColonias,
          });
        }
      });
  }
  // Dirección de la Empresa Alterna: cascada propia, independiente de la de
  // "Direcciones" del cliente (que es un arreglo indexado por fieldKey).
  onChangeEstadoAlterna(value, inicial) {
    if (!inicial) {
      const empresaAlterna = this.formRef.current.getFieldValue("empresaAlterna") || {};
      this.formRef.current.setFieldsValue({
        empresaAlterna: { ...empresaAlterna, municipioId: undefined, coloniaId: undefined },
      });
      this.setState({ objetoMunicipiosAlterna: null, objetoColoniasAlterna: null });
    }
    axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            objetoMunicipiosAlterna: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre}</Option>
            )),
          });
        }
      });
  }
  onChangeMunicipioAlterna(value, inicial) {
    if (!inicial) {
      const empresaAlterna = this.formRef.current.getFieldValue("empresaAlterna") || {};
      this.formRef.current.setFieldsValue({
        empresaAlterna: { ...empresaAlterna, coloniaId: undefined },
      });
      this.setState({ objetoColoniasAlterna: null });
    }
    axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            objetoColoniasAlterna: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.cp + " - " + value.nombre}</Option>
            )),
          });
        }
      });
  }
  async onChangeArchivoLogoAlterna(e) {
    const file = e.file;
    if (file.type === "image/jpeg" || file.type === "image/png") {
      const base64 = await getBase64(file);
      this.setState({ archivoLogoAlterna: file, base64LogoAlterna: base64 });
      e.onSuccess("ok");
    } else {
      message.error("El logo debe ser una imagen");
      e.onError("Formato inválido");
    }
  }
  onChangeTipoDeCliente(value) {
    const tipoDeCliente = this.state.todasTipoDeCliente.find(
      (valueTodos) => valueTodos._id.toString() === value.toString()
    );
    if (
      tipoDeCliente.generarCuentasAutomatico &&
      value !== this.state.dataInicial?.tipoClienteId
    ) {
      this.formRef.current.setFieldsValue({
        cuentaClienteId: this.state.dataInicial?.cuentaClienteId || "Se generara al guardarlo",
        cuentaAnticipoId: this.state.dataInicial?.cuentaAnticipoId || "Se generara al guardarlo",
        generarCuentaAnticipoId: false,
        cuentaFonGarId: this.state.dataInicial?.cuentaFonGarId || "Se generara al guardarlo",
        generarCuentaFonGarId: false,
        cuentaDeudorId: this.state.dataInicial?.cuentaDeudorId || "Se generara al guardarlo",
        generarCuentaDeudorId: false,
      });
    } else {
      this.formRef.current.setFieldsValue({
        cuentaClienteId: tipoDeCliente.cuentaClienteId,
        cuentaAnticipoId: tipoDeCliente.cuentaAnticipoId,
        generarCuentaAnticipoId: false,
        cuentaFonGarId: tipoDeCliente.cuentaFonGarId,
        generarCuentaFonGarId: false,
        cuentaDeudorId: tipoDeCliente.cuentaDeudorId,
        generarCuentaDeudorId: false,
      });
    }
  }
  onSearchColonia(value, fieldKey, ponerColoniaId) {
    if (value.toString().length === 5) {
      axios
        .post(
          "colonias/buscarCP",
          { cp: value },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.info("No se encontro el codigo postal");
          } else {
            let direcciones = this.formRef.current.getFieldValue("direcciones");
            if (typeof direcciones[fieldKey] === "undefined") {
              direcciones[fieldKey] = {};
            }
            if (ponerColoniaId && res.data._id) {
              direcciones[fieldKey].coloniaId = res.data._id;
            }
            direcciones[fieldKey].paisId = res.data.paisId;
            direcciones[fieldKey].estadoId = res.data.estadoId;
            direcciones[fieldKey].municipioId = res.data.municipioId;
            this.formRef.current.setFieldsValue({
              direcciones: direcciones,
            });
            this.onChangeEstado(res.data.estadoId, fieldKey, true);
            this.onChangeMunicipio(res.data.municipioId, fieldKey, true);
          }
        });
    }
  }
  async onSelectColoniaId(coloniaId, fieldKey) {
    const direcciones = this.formRef.current.getFieldValue("direcciones");
    if (typeof direcciones[fieldKey] === "undefined") {
      direcciones[fieldKey] = {};
    }
    if (!direcciones[fieldKey].colonia) {
      const nombreColonia = this.state.todasColonias.find(
        (todasColonia) => todasColonia._id.toString() === coloniaId.toString()
      )?.nombre;
      direcciones[fieldKey].colonia = nombreColonia;
      await this.formRef.current.setFieldsValue({
        direcciones: direcciones,
      });
    }
  }
  async onChangeRfc(e) {
    this.formRef.current
      .validateFields(["rfc"])
      .then(() => {
        if (e.target.value) {
          if (e.target.value.length === 13) {
            //Persona Fisica
            this.formRef.current.setFieldsValue({ persona: false });
          } else if (e.target.value.length === 12) {
            //Persona Moral
            this.formRef.current.setFieldsValue({ persona: true });
          }
        }
      })
      .catch((err) => undefined);
  }
  onChangeRegimenFiscal(regimenFiscalId) {
    if (!this.state.utilizado) {
      const retencionAgregar = this.state.todasRetenciones.find(
        (todasRetenciones) =>
          todasRetenciones.regimenFiscalId.toString() ===
          regimenFiscalId.toString()
      );
      const retenciones = this.formRef.current.getFieldValue("retenciones");
      if (retencionAgregar) {
        if (retenciones) {
          const findRetencion = retenciones.find(
            (todasRetencionesProv) =>
              todasRetencionesProv.retencionId.toString() ===
              retencionAgregar._id.toString()
          );
          if (!findRetencion) {
            this.formRef.current.setFieldsValue({
              retenciones: [
                ...retenciones,
                { retencionId: retencionAgregar._id },
              ],
            });
          }
        } else {
          this.formRef.current.setFieldsValue({
            retenciones: [{ retencionId: retencionAgregar._id }],
          });
        }
      }
    }
  }

  async onChangeArchivo(e) {
    this.setState({ loading: true });
    if (e.file.type === "application/pdf") {
      const datosConstancia = await extraerDatosConstanciaFiscal(e.file);
      if (datosConstancia.persona === 1) {
        if (
          datosConstancia.rfc &&
          datosConstancia.nombre &&
          datosConstancia.apellidoPaterno &&
          datosConstancia.codigoPostal
        ) {
          const findRegimen = this.state.todasRegimenFiscal.find(
            (valueTRe) =>
              calcularSimilitud(
                valueTRe.descripcion,
                datosConstancia.regimenFiscal
              ) > 65
          );
          this.onSearchColonia(datosConstancia.codigoPostal, 0, true);
          this.formRef.current.setFieldsValue({
            rfc: datosConstancia.rfc,
            curp: datosConstancia.curp,
            nombre: datosConstancia.nombre,
            regimenFiscalId: findRegimen ? findRegimen._id : undefined,
            apellidoPaterno: datosConstancia.apellidoPaterno,
            apellidoMaterno: datosConstancia.apellidoMaterno,
            nombreComercial: datosConstancia.nombreComercial,

            direcciones: [
              {
                calle: datosConstancia.calle,
                numeroCalle: datosConstancia.numeroExterior,
                numeroInterior: datosConstancia.numeroInterior,
                colonia: datosConstancia.colonia,
                codigoPostal: datosConstancia.codigoPostal,
              },
            ],
            persona: false,
          });
        } else {
          message.error("No se pudo leer bien el archivo");
        }
      } else if (datosConstancia.persona === 2) {
        if (
          datosConstancia.rfc &&
          datosConstancia.razonSocial &&
          datosConstancia.codigoPostal
        ) {
          this.onSearchColonia(datosConstancia.codigoPostal, 0, true);
          const findRegimen = this.state.todasRegimenFiscal.find(
            (valueTRe) =>
              calcularSimilitud(
                valueTRe.descripcion,
                datosConstancia.regimenFiscal
              ) > 65
          );
          this.formRef.current.setFieldsValue({
            razonSocial: datosConstancia.razonSocial,
            rfc: datosConstancia.rfc,
            regimenFiscalId: findRegimen ? findRegimen._id : undefined,
            curp: datosConstancia.curp,
            nombreComercial: datosConstancia.nombreComercial,

            direcciones: [
              {
                calle: datosConstancia.calle,
                numeroCalle: datosConstancia.numeroExterior,
                numeroInterior: datosConstancia.numeroInterior,
                colonia: datosConstancia.colonia,
                codigoPostal: datosConstancia.codigoPostal,
              },
            ],
            persona: true,
          });
        } else {
          message.error("No se pudo leer bien el archivo");
        }
      } else {
        message.error("No se pudo leer bien el archivo");
      }
    } else {
      message.error("El archivo debe ser un archivo pdf");
    }
    this.setState({ loading: false });
  }

  onChangeCodigo(value, fieldKey) {
    let buscarInfoCodes = this.state.buscarInfoCodes;

    buscarInfoCodes[fieldKey] = true;

    this.setState({ buscarInfoCodes });

    axios
      .post(
        "codigoinsumos/buscarCodigoLista",
        { empresaId: this.props.empresaId, codigo: value },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          let objetoCodigosSat = this.state.objetoCodigosSat;
          objetoCodigosSat[fieldKey] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.c_ClaveProdServ + " - " + value.descripcion}
              </Option>
            );
          });

          buscarInfoCodes[fieldKey] = false;

          this.setState({
            buscarInfoCodes,
            objetoCodigosSat,
          });
        }
      });
  }

  abrirAgregarUnidad() {
    this.setState({ modalAgregarUnidad: true });
  }

  cerrarAgregarUnidad(codigo) {
    this.setState({ modalAgregarUnidad: false });
    this.consultarTodo().then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ unidadId: codigo });
      }
    });
  }
  onSearchPlantaEntrega = (value, fieldKey, opts = {}) => {
    const { byId = false, setSelected = false } = opts;
    if (byId) {
      axios
        .post(
          "plantaDeEntrega/selectPlantaEntregaPorId",
          { id: value },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          const p = res?.data?.dato || null;
          if (!p || !p._id) {
            this.setState((prev) => ({
              objetoPlantasEntrega: {
                ...prev.objetoPlantasEntrega,
                [fieldKey]: [],
              },
              loadingPlantasEntrega: {
                ...prev.loadingPlantasEntrega,
                [fieldKey]: false,
              },
            }));
            message.warning("No se encontró la planta por ID.");
            return;
          }

          const option = (
            <Option key={p._id} value={p._id} padre={p.plantaEntregaId}>
              {p.label}
            </Option>
          );

          this.setState((prev) => ({
            objetoPlantasEntrega: {
              ...prev.objetoPlantasEntrega,
              [fieldKey]: [option],
            },
            loadingPlantasEntrega: {
              ...prev.loadingPlantasEntrega,
              [fieldKey]: false,
            },
          }));

          if (
            setSelected &&
            (this.props.form?.setFieldsValue || this.form?.setFieldsValue)
          ) {
            const form = this.props.form || this.form;
            form.setFields([
              {
                name: ["direcciones", fieldKey, "plantaEntregaId"],
                value: p._id,
              },
            ]);
          }
        })
        .catch((err) => {
          console.error(err);
          message.error("Error al buscar planta por ID");
          this.setState((prev) => ({
            objetoPlantasEntrega: {
              ...prev.objetoPlantasEntrega,
              [fieldKey]: [],
            },
            loadingPlantasEntrega: {
              ...prev.loadingPlantasEntrega,
              [fieldKey]: false,
            },
          }));
        });

      return;
    }
    this.setState((prev) => ({
      loadingPlantasEntrega: {
        ...prev.loadingPlantasEntrega,
        [fieldKey]: true,
      },
    }));
    axios
      .post(
        "plantaDeEntrega/selectPlantasDeEntrega",
        {
          query: value || "",
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res?.data.success !== 2) {
          this.setState((prev) => ({
            objetoPlantasEntrega: {
              ...prev.objetoPlantasEntrega,
              [fieldKey]: [],
            },
            loadingPlantasEntrega: {
              ...prev.loadingPlantasEntrega,
              [fieldKey]: false,
            },
          }));
          return;
        }
        const items = Array.isArray(res.data.plantas) ? res.data.plantas : [];
        const options = items.map((it) => (
          <Option key={it._id} value={it._id} padre={it.plantaEntregaId}>
            {it.label}
          </Option>
        ));

        this.setState((prev) => ({
          objetoPlantasEntrega: {
            ...prev.objetoPlantasEntrega,
            [fieldKey]: options,
          },
          loadingPlantasEntrega: {
            ...prev.loadingPlantasEntrega,
            [fieldKey]: false,
          },
        }));
      })
      .catch((err) => {
        console.error(err);
        message.error("Error al buscar plantas de entrega");
        this.setState((prev) => ({
          objetoPlantasEntrega: {
            ...prev.objetoPlantasEntrega,
            [fieldKey]: [],
          },
          loadingPlantasEntrega: {
            ...prev.loadingPlantasEntrega,
            [fieldKey]: false,
          },
        }));
      });
  };

  async consultarDirecciones() {
    this.setState({ loading: true });
    await axios
      .post(
        "clientes/direccionesCliente",
        { empresaId: this.props.empresaId, clienteId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion del cliente");
        } else {

          const opcionesMunicipios = [];
          const opcionesColonias = [];
          const opcionesPlantaEntrega = [];

          const direccionesActualizadas = res.data.direcciones.map(
            (valueDireccion) => {
              const direccion = { ...valueDireccion };

              if (direccion.municipioId) {
                const value = direccion.municipioId;
                const opcion = (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
                opcionesMunicipios.push(opcion);
                direccion.municipioId = value._id;
              }

              if (direccion.coloniaId) {
                const value = direccion.coloniaId;
                const opcion = (
                  <Option value={value._id} key={value._id}>
                    {value.cp + " - " + value.nombre}
                  </Option>
                );
                opcionesColonias.push(opcion);
                direccion.coloniaId = value._id;
              }

              if (direccion.plantaEntregaId) {
                const value = direccion.plantaEntregaId;
                const opcion = (
                  <Option
                    key={value._id}
                    value={value._id}
                    valueadre={value.PlantaEntregaId}
                  >
                    {value.plantaEntregaId + " - " + value.centroDistribucion}
                  </Option>
                );
                opcionesPlantaEntrega.push(opcion);
                direccion.plantaEntregaId = value._id;
              }

              return direccion;
            }
          );

          this.setState({
            objetoMunicipios: opcionesMunicipios,
            objetoColonias: opcionesColonias,
            objetoPlantasEntrega: opcionesPlantaEntrega,
          });
          if (this.formRef.current) {
            this.formRef.current.setFieldsValue({
              direcciones: direccionesActualizadas,
            });
          }
        }
      })
      .catch((err) => {
        console.error("Error al consultar direcciones:", err);
        message.error("Ocurrió un error al consultar las direcciones.");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  //Funciones para los archivos 
  onRemoveFile(e) {
    let index = this.state.archivosCliente.indexOf(e);
    let nuevoArray = this.state.archivosCliente;
    nuevoArray.splice(index, 1);
    this.setState({ archivosCliente: nuevoArray });
  }
  async customRequestArchivos(e) {
    const file = e.file;
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isLt5M) {
      message.error(`${file.name} supera los 5 MB`);
      e.onError('Archivo demasiado grande');
      return;
    }
    const base64 = await getBase64(file);

    const nuevoArchivo = {
      uid: file.uid,
      name: file.name,
      status: 'done',
      url: base64,
      originFileObj: file,
    };


    this.setState({
      archivosCliente: [...this.state.archivosCliente, nuevoArchivo],
    });

    e.onSuccess("ok");
  }
  beforeUploadArchivos = (file, fileList) => {
    const { archivosCliente, maximoArchivos } = this.state;
    const totalProyectado = archivosCliente.length + fileList.length;

    if (totalProyectado > maximoArchivos) {
      if (file === fileList[0]) {
        message.error(`Con esta selección, superarías el límite de ${maximoArchivos} archivos.`);
      }
      return Upload.LIST_IGNORE;
    }

    const isLt25M = file.size / 1024 / 1024 < 25;
    if (!isLt25M) {
      message.error(`${file.name} excede el tamaño máximo de 25MB`);
      return Upload.LIST_IGNORE;
    }
    return true;
  };
  handlePreview = (file) => {
    this.setState({
      currentPreviewFile: file,
      filePreviewVisible: true,
    });
  };

  handleCloseFilePreview = () => {
    this.setState({
      filePreviewVisible: false,
      currentPreviewFile: null,
    });
  };

  // ------- Insumos x Cliente -------

  consultarInsumosPersonalizados(params = {}) {
    this.setState({ loadingInsumosPersonalizados: true });
    axios
      .post(
        "insumosCliente/selectInsumosPersonalizadosCliente",
        {
          empresaId: this.props.empresaId,
          clienteId: this.state.id,
          page: params.page || 1,
          pageSize: params.pageSize || 10,
          query: params.query,
          filters: params.filters,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            insumosPersonalizadosData: res.data.data,
            insumosPersonalizadosTotal: res.data.totalRecords,
          });
        }
        this.setState({ loadingInsumosPersonalizados: false });
      })
      .catch(() => this.setState({ loadingInsumosPersonalizados: false }));
    this.consultarInsumoIdsConfigurados();
  }


  consultarInsumoIdsConfigurados() {
    axios
      .post(
        "insumosCliente/selectInsumoIdsCliente",
        { empresaId: this.props.empresaId, clienteId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ insumoIdsConfigurados: res.data.insumoIds });
        }
      });
  }

  abrirModalInsumoPersonalizado(item) {
    this.setState({
      modalInsumoPersonalizadoVisible: true,
      insumoPersonalizadoEditando: item || null,
    });
  }

  cerrarModalInsumoPersonalizado() {
    this.setState({
      modalInsumoPersonalizadoVisible: false,
      insumoPersonalizadoEditando: null,
    });
  }

  guardarInsumoPersonalizado(valores) {
    const { insumoId, equivalenciaId, nombreAlternativo, clave, presentacion, precio, unidadId, conversion } = valores;
    if (!insumoId || !nombreAlternativo?.trim()) {
      return message.warning('Selecciona un insumo y captura el nombre para el cliente');
    }

    const { insumoPersonalizadoEditando } = this.state;

    const datos = {
      empresaId: this.props.empresaId,
      clienteId: this.state.id,
      insumoId,
      equivalenciaId,
      nombreAlternativo: nombreAlternativo.trim(),
      clave,
      presentacion,
      precio,
      unidadId,
      conversion,
    };

    const url = insumoPersonalizadoEditando
      ? "insumosCliente/editarInsumoPersonalizadoCliente"
      : "insumosCliente/agregarInsumoPersonalizadoCliente";

    if (insumoPersonalizadoEditando) {
      datos.itemId = insumoPersonalizadoEditando._id;
    }

    this.setState({ guardandoInsumoPersonalizado: true });
    axios.post(url, datos, { headers: this.props.headersToken }).then((res) => {
      this.setState({ guardandoInsumoPersonalizado: false });
      if (res.data.success === 2) {
        message.success(insumoPersonalizadoEditando ? "Insumo actualizado" : "Insumo agregado");
        this.cerrarModalInsumoPersonalizado();
        if (this.insumosPersonalizadosTableRef) {
          this.insumosPersonalizadosTableRef.updateExternalFilters({});
        } else {
          this.consultarInsumosPersonalizados();
        }
      } else {
        message.warning(res.data.message || "No se pudo guardar el insumo");
      }
    }).catch(() => this.setState({ guardandoInsumoPersonalizado: false }));
  }

  eliminarInsumoPersonalizado(item) {
    axios
      .post(
        "insumosCliente/eliminarInsumoPersonalizadoCliente",
        { empresaId: this.props.empresaId, clienteId: this.state.id, itemId: item._id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Insumo eliminado");
          if (this.insumosPersonalizadosTableRef) {
            this.insumosPersonalizadosTableRef.updateExternalFilters({});
          } else {
            this.consultarInsumosPersonalizados();
          }
        } else {
          message.warning(res.data.message || "No se pudo eliminar el insumo");
        }
      });
  }

  irAEdicionMasivaInsumosCliente() {
    this.props.history.push('/panel/edicionMasivaInsumosCliente', {
      clienteId: this.state.id,
      clienteNombre: this.formRef.current?.getFieldValue('razonSocial') || this.formRef.current?.getFieldValue('nombreComercial') || '',
    });
  }

  irACapturaInsumosCliente() {
    this.props.history.push('/panel/capturaInsumosCliente', {
      clienteId: this.state.id,
      clienteNombre: this.formRef.current?.getFieldValue('razonSocial') || this.formRef.current?.getFieldValue('nombreComercial') || '',
    });
  }

  confirmarSubidaExcelInsumos(filas, limpiarSeccion) {
    const lista = filas.map((fila) => ({
      insumoId: fila.insumoId,
      equivalenciaId: fila.equivalenciaId,
      nombreAlternativo: fila.nombreAlternativo,
      clave: fila.clave,
      presentacion: fila.presentacion,
      precio: fila.precio,
      unidadId: fila.unidadId,
      conversion: fila.conversion || 1,
    }));

    this.setState({ guardandoInsumosBulk: true });
    axios
      .post(
        "insumosCliente/agregarInsumosPersonalizadosClienteBulk",
        { empresaId: this.props.empresaId, clienteId: this.state.id, lista },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardandoInsumosBulk: false });
        if (res.data.success === 2) {
          message.success(`Se agregaron ${res.data.agregados} insumo(s)${res.data.omitidos > 0 ? `, se omitieron ${res.data.omitidos} duplicado(s)` : ''}`);
          if (limpiarSeccion) limpiarSeccion();
          if (this.insumosPersonalizadosTableRef) {
            this.insumosPersonalizadosTableRef.updateExternalFilters({});
          } else {
            this.consultarInsumosPersonalizados();
          }
        } else {
          message.warning(res.data.message || "No se pudo subir la lista");
        }
      })
      .catch(() => this.setState({ guardandoInsumosBulk: false }));
  }

  render() {
    const { filePreviewVisible, currentPreviewFile, camposObligatorios } = this.state;
    const esEmpresaEspecial = this.props.empresaId === '6949999f814dca4f7c54c4d6';

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Editar Cliente"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <Upload
                showUploadList={{
                  showRemoveIcon: false,
                  showPreviewIcon: false,
                }}
                fileList={[]}
                customRequest={this.onChangeArchivo.bind(this)}
                accept=".pdf"
                maxCount={this.state.maximoArchivos}
              >
                <ButtonItem blanco icon={<UploadOutlined />}>
                  Leer Constancia
                </ButtonItem>
              </Upload>
              <ButtonItem
                type="primary"
                azul
                icon={<SafetyCertificateOutlined />}
                onClick={this.validarDatosClienteSAT.bind(this)}
              >
                Validar en SAT
              </ButtonItem>
              {this.props.ventaOnline && this.props.permisoCrearUsuariosEcommerce && (
                <ButtonItem
                  type="primary"
                  morado
                  onClick={() =>
                    this.setState({ modalUsuarioEcommerceVisible: true })
                  }
                >
                  Usuario Ecommerce
                </ButtonItem>
              )}
              {this.props.appMovil && this.props.permisoControlUsuarioMovil && (
                <ButtonItem
                  blanco
                  icon={<MobileOutlined />}
                  onClick={() => this.setState({ modalUsuarioMovil: true })}
                >
                  Usuario Móvil
                </ButtonItem>
              )}
            </div>
          }
        />
        <div className="card-background" style={{ paddingTop: 20 }}>
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarCliente"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  cyan
                  style={{ display: "block", margin: "0 0 0 auto",minWidth: 120,height: 30, }}

                >
                  Guardar Cliente
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
              initialValues={{
                monedaId: "60c7e4396465ad440c41c15a",
                direcciones: [],
              }}
            >
              <TabbedDynamicTable
                defaultActiveKey="1"
                onTabChange={async (key) => {
                  if (key === "8") {
                    await this.setState({ loadingMercancias: true });

                    await axios
                      .post(
                        "envios/datosMercanciaFlete",
                        { empresaId: this.props.empresaId },
                        {
                          headers: this.props.headersToken,
                        }
                      )
                      .then((res) => {
                        if (res.data.success === 2) {
                          this.setState({
                            todasUnidades: res.data.unidades,
                            todasMaterialesPeligrosos:
                              res.data.materialesPeligrosos,
                            todasEmbalajes: res.data.embalajes,
                            unidadPeso: res.data.unidadPeso,
                            todasSectoresCOF: res.data.sectoresCOF,
                            todasFormasFarmaceuticas:
                              res.data.formasFarmaceuticas,
                            todasCondicionesEspeciales:
                              res.data.condicionesEspeciales,
                            todasTiposMaterias: res.data.tiposMaterias,
                            objetoUnidades: res.data.unidades.map((value) => {
                              return (
                                <Option value={value._id} key={value._id}>
                                  {value.unidadSat.c_ClaveUnidad +
                                    " - " +
                                    value.nombre}
                                </Option>
                              );
                            }),
                            objetoMaterialesPeligrosos:
                              res.data.materialesPeligrosos.map((value) => {
                                return (
                                  <Option value={value._id} key={value._id}>
                                    {value.Clave + " - " + value.Descripcion}
                                  </Option>
                                );
                              }),
                            objetoEmbalajes: res.data.embalajes.map((value) => {
                              return (
                                <Option value={value._id} key={value._id}>
                                  {value.Clave + " - " + value.Descripcion}
                                </Option>
                              );
                            }),
                            objetoSectoresCOF: res.data.sectoresCOF.map(
                              (value) => {
                                return (
                                  <Option value={value._id} key={value._id}>
                                    {value.Clave + " - " + value.Descripcion}
                                  </Option>
                                );
                              }
                            ),
                            objetoFormasFarmaceuticas:
                              res.data.formasFarmaceuticas.map((value) => {
                                return (
                                  <Option value={value._id} key={value._id}>
                                    {value.Clave + " - " + value.Descripcion}
                                  </Option>
                                );
                              }),
                            objetoCondicionesEspeciales:
                              res.data.condicionesEspeciales.map((value) => {
                                return (
                                  <Option value={value._id} key={value._id}>
                                    {value.Clave + " - " + value.Descripcion}
                                  </Option>
                                );
                              }),
                            objetoTiposMaterias: res.data.tiposMaterias.map(
                              (value) => {
                                return (
                                  <Option value={value._id} key={value._id}>
                                    {value.Clave + " - " + value.Descripcion}
                                  </Option>
                                );
                              }
                            ),
                          });
                        } else {
                          message.info(
                            "No se cargaron bien los datos de las mercancias"
                          );
                        }
                      });

                    const objetoCodigosSat = Array.isArray(
                      this.state.mercanciasEnvio
                    )
                      ? await Promise.all(
                        this.state.mercanciasEnvio.map(
                          async (valueMer, kerMer) => {
                            const codigos = await axios.post(
                              "codigoinsumos/buscarCodigoLista",
                              {
                                empresaId: this.props.empresaId,
                                subClaseId: valueMer.codigoSatId,
                              },
                              { headers: this.props.headersToken }
                            );

                            if (codigos.data.status === 404) {
                              return null;
                            } else {
                              return codigos.data.map((value) => {
                                return (
                                  <Option value={value._id} key={value._id}>
                                    {value.c_ClaveProdServ +
                                      " - " +
                                      value.descripcion}
                                  </Option>
                                );
                              });
                            }
                          }
                        )
                      )
                      : [];

                    const buscarInfoCodes = this.state.mercanciasEnvio
                      ? this.state.mercanciasEnvio.map((valueMer) => false)
                      : [];

                    await this.setState({
                      loadingMercancias: false,
                      buscarInfoCodes,
                      objetoCodigosSat,
                    });
                  }

                  if (key === "4") {
                    this.consultarDirecciones();
                  }

                  if (key === "13" && !this.state.historialCargado) {
                    this.consultarHistorial();
                  }
                }}
                tabs={[
                  {
                    key: '1',
                    label: 'General',
                    forceRender: true,
                    customContent: (
                      <>
                      <Row gutter={16}>      
                      {/* ===================== DATOS GENERALES ===================== */}
                      <Col span={12} xs={24} lg={13}>
                        <DynamicCardForm
                          title={<span>Datos Generales</span>}
                        >
                          <Row>
                            <Col span={12}>
                              <FormItem name="codigo" margin label="Código" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                                <InputItem disabled />
                              </FormItem>
                            </Col>

                            <Col span={12}>
                              <FormItem name="clave" margin pattern required={!!camposObligatorios.clave} label="Clave" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                                <InputItem />
                              </FormItem>
                            </Col>
                          </Row>

                          <Row>
                            <Col span={12}>
                              <FormItem name="rfc" label="RFC" margin required labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                                <InputItem />
                              </FormItem>
                            </Col>
                            
                            <Col span={12}>
                              <FormItem name="persona" label="P. Moral" margin valuePropName="checked" initialValue={false} labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}>
                                <Checkbox />
                              </FormItem>
                            </Col>
                            
                          </Row>

                          <Row>
                              <Col span={12}>
                                <FormItem shouldUpdate margin noStyle>
                                  {({ getFieldValue }) =>
                                    !getFieldValue("persona") && (
                                      <FormItem name="curp" label="CURP" margin pattern max={20} required={!!camposObligatorios.curp} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                                        <InputItem />
                                      </FormItem>
                                    )
                                  }
                                </FormItem>
                              </Col>
                          </Row>
                                                 
                         
                                               
                          <Col span={23} xs={24} sm={24} lg={23} xl={23}>
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) =>
                                  getFieldValue("persona") && (
                                    <FormItem name="razonSocial" label="Razón Social" margin pattern max={200} labelCol={{ span: 3}} wrapperCol={{ span:21 }} required>
                                      <InputItem />
                                    </FormItem>
                                  )
                                }
                              </FormItem>
                            </Col>
                          <Row>

                          <Col span={10} xs={24} sm={24} lg={9} xl={9}>
                            <FormItem shouldUpdate noStyle>
                              {({ getFieldValue }) => {
                                if (!getFieldValue("persona")) {
                                  return (
                                    <FormItem
                                      label="Nombre"
                                      margin
                                      pattern
                                      required
                                      name="nombre"
                                      labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 3 } }}
                                      wrapperCol={{ lg: { span: 16 }, xl: { span: 16 }, xs: { span: 21 } }}
                                    >
                                      <InputItem
                                        placeholder="Nombre persona física"
                                        width="98%"
                                      />
                                    </FormItem>
                                  );
                                }
                              }}
                            </FormItem>
                          </Col>
                          <Col span={7} xs={24} sm={24} lg={7} xl={7}>
                            <FormItem shouldUpdate noStyle>
                              {({ getFieldValue }) => {
                                if (!getFieldValue("persona")) {
                                  return (
                                    <FormItem
                                      margin
                                      pattern
                                      name="apellidoPaterno"
                                      required={!!camposObligatorios.apellidoPaterno}
                                      labelCol={{ lg: { span: 0}, xl: { span: 0 }, xs: { span: 20 } }}
                                      wrapperCol={{ span: 24 }}
                                    >
                                      <InputItem
                                        placeholder="Apellido Paterno"
                                        width="98%"
                                      />
                                    </FormItem>
                                  );
                                }
                              }}
                            </FormItem>
                          </Col>
                          <Col span={7} xs={24} sm={24} lg={7} xl={7}>
                            <FormItem shouldUpdate noStyle>
                              {({ getFieldValue }) => {
                                if (!getFieldValue("persona")) {
                                  return (
                                    <FormItem
                                      margin
                                      pattern
                                      name="apellidoMaterno"
                                      required={!!camposObligatorios.apellidoMaterno}
                                      labelCol={{ span: 0 }}
                                      wrapperCol={{ span: 24 }}
                                    >
                                      <InputItem placeholder="Apellido Materno" width="98%" />
                                    </FormItem>
                                  );
                                }
                              }}
                            </FormItem>
                          </Col>
                        </Row>

                        <Col span={23} xs={24} sm={24} lg={23} xl={23}>
                            <FormItem
                              shouldUpdate={(prev, cur) => prev.rfc !== cur.rfc}
                              noStyle
                            >
                              {({ getFieldValue }) =>
                                getFieldValue("rfc") === "XEXX010101000" && (
                                  <Row gutter={[16, 0]}>
                                    <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                      <FormItem
                                        label="ID Trib."
                                        name="registroIDTributario"
                                        margin
                                        pattern
                                        labelCol={{ span: 6 }}
                                        wrapperCol={{ span: 18 }}
                                        tooltip="Número de Registro de Identificación Tributaria del extranjero"
                                      >
                                        <InputItem placeholder="Ej: VAT-DE123456789" />
                                      </FormItem>
                                    </Col>
                                    <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                      <FormItem
                                        label="Residencia Fiscal"
                                        name="paisResidenciaId"
                                        margin
                                        labelCol={{ span: 8 }}
                                        wrapperCol={{ span: 16 }}
                                      >
                                        <SelectItem placeholder="Residencia Fiscal">
                                          {this.state.objetoPaisesResidencia}
                                        </SelectItem>
                                      </FormItem>
                                    </Col>
                                  </Row>
                                )
                              }
                            </FormItem>
                        </Col>

                         <Col span={23} xs={24} sm={24} lg={23} xl={23}>
                            <FormItem
                              name="nombreComercial" pattern max={200} required={!!camposObligatorios.nombreComercial} labelCol={{ span: 3 }} wrapperCol={{ span: 21}} label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Nombre Comercial</span>} margin
                            >
                              <InputItem />
                            </FormItem>
                        </Col>
                        </DynamicCardForm>

                        <DynamicCardForm
                          title="Contacto General"
                        >
                          <Row>
                              <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                <FormItem name="nombreContactoGeneral" margin pattern max={200} required={!!camposObligatorios.nombreContactoGeneral} labelCol={{ span: 4 }} wrapperCol={{ span: 18 }} label="Nombre">
                                  <InputItem placeholder="Nombre de Contacto" />
                                </FormItem>
                              </Col>
                          </Row>
                          <Row>
                              <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                <FormItem name="celular" margin required={!!camposObligatorios.celular || esEmpresaEspecial} labelCol={{ lg: { span: 8}, xl: { span: 8}, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }} label="Celular">
                                  <InputNumberItem />
                                </FormItem>

                                <FormItem name="telefono" margin required={!!camposObligatorios.telefono} labelCol={{ lg: { span: 8}, xl: { span: 8}, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }} label="Teléfono">
                                  <InputNumberItem />
                                </FormItem>
                              </Col>

                              <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                <FormItem name="paginaWeb" margin pattern required={!!camposObligatorios.paginaWeb} labelCol={{ lg: { span: 8}, xl: { span: 8}, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }} label="Página Web">
                                  <InputItem />
                                </FormItem>

                                <FormItem name="correo" margin required={!!camposObligatorios.correo || esEmpresaEspecial} pattern max={200} email labelCol={{ lg: { span: 8}, xl: { span: 8}, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }} label="Correo">
                                  <InputItem />
                                </FormItem>
                              </Col>
                          </Row>
                          <Row>
                              <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                              <FormItem margin pattern required={!!camposObligatorios.observaciones} labelCol={{ span: 4 }} wrapperCol={{ span: 18 }} name="observaciones" label="Observaciones">
                                <TextAreaItem />
                              </FormItem>                            
                            </Col>
                          </Row>
                          <Row>
                              <Col span={24}>
                                <FormItem name="impresionEspecial" label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Impresión Especial</span>} margin required={!!camposObligatorios.impresionEspecial} rules={!!camposObligatorios.impresionEspecial ? [{ validator: (_, v) => v ? Promise.resolve() : Promise.reject(new Error('Debes activar Impresión Especial')) }] : []} valuePropName="checked" initialValue={false} labelCol={{ span: 4}} wrapperCol={{ span: 19 }}>
                                  <Checkbox />
                                </FormItem>
                              </Col>
                          </Row>
                            <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                const usaAdenda = getFieldValue("usarAdenda");
                                const esViscofan = getFieldValue("adendaActiva") === "Viscofan";
                                const campoObligatorio = usaAdenda && esViscofan;
    
                                return (
                                    <FormItem
                                    label="Código Proveedor"
                                    name="codigoProveedor"
                                    pattern
                                    max={9}
                                    margin
                                    required={campoObligatorio || !!camposObligatorios.codigoProveedor}
                                    labelCol={{ span: 4 }}
                                    wrapperCol={{ lg: { span: 18}, xl: { span: 18}, xs: { span: 18 } }} 
                                    >
                                    <InputItem placeholder="Código de Proveedor" />
                                    </FormItem>
                                );
                                }}
                            </FormItem>
                          <Row>
                            <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                <FormItem name="fechaAlta" label="Fecha Alta" pattern labelCol={{ span: 4}} wrapperCol={{ span: 18 }}>
                                  <InputItem disabled />
                                </FormItem>
                            </Col>
                          </Row>
                        </DynamicCardForm>
                      </Col>

                      {/* ===================== DATOS VENTA ===================== */}
                      <Col span={12} xs={24} lg={11}>
                        <DynamicCardForm
                          title="Datos Venta"
                        >
                        <FormItem
                            label="Tipo Cliente"
                            margin
                            name="tipoClienteId"
                            required
                            labelCol={{ span: 7 }}
                            wrapperCol={{ span: 16 }}
                            >
                            <SelectItem
                                //width='120%'
                                // El cliente que YA tiene tipo cambia solo por el modal:
                                // el select de aqui va por editarCliente, que no reasigna
                                // las cuentas ya generadas (deja la subcuenta colgada del
                                // arbol del tipo anterior) ni genera la poliza de
                                // reclasificacion. Si no tiene tipo todavia (importados,
                                // punto de venta) se sigue pudiendo asignar aqui.
                                disabled={!!this.state.dataInicial?.tipoClienteId}
                                placeholder="Tipo de Cliente"
                                onChange={this.onChangeTipoDeCliente.bind(this)}
                            >
                                {this.state.objetoTipoDeCliente}
                            </SelectItem>
                        </FormItem>
                        {this.state.dataInicial?.tipoClienteId ? (
                          <div style={{ textAlign: "right", marginBottom: 8 }}>
                            <ButtonItem
                              type="primary"
                              blanco
                              size="small"
                              onClick={() => this.setState({ modalCambiarTipo: true })}
                            >
                              Cambiar tipo de cliente
                            </ButtonItem>
                          </div>
                        ) : null}

                         <FormItem
                            name="regimenFiscalId"
                            label="R. Fiscal"
                            margin
                            required={!!camposObligatorios.regimenFiscalId || esEmpresaEspecial}
                            tooltip={{
                                title: "Campo necesario para facturación",
                            }}
                            labelCol={{ span: 7 }}
                            wrapperCol={{ span: 16 }}
                            >
                            <SelectItem
                                onChange={this.onChangeRegimenFiscal.bind(this)}
                                placeholder="Regimen Fiscal"
                            >
                                {this.state.objetoRegimenFiscal}
                            </SelectItem>
                        </FormItem>

                        <FormItem name="usoDeCFDIID" margin required={!!camposObligatorios.usoDeCFDIID || esEmpresaEspecial} label="Uso de CFDI" labelCol={{ span: 7 }}  wrapperCol={{ span: 16 }}>
                                <SelectItem>
                                {this.state.objetoUsosDeCFDI}
                                </SelectItem>
                          </FormItem>
                           <FormItem
                              name="proyectoId"
                              fieldKey="proyectoId"
                              label="Proyecto"
                              margin
                              required={!!camposObligatorios.proyectoId || esEmpresaEspecial}
                              labelCol={{ span: 7 }}
                              wrapperCol={{ span: 16 }}
                            >
                              <SelectItem placeholder="Proyecto">
                                {this.state.objetoProyectos}
                              </SelectItem>
                            </FormItem>

                          <FormItem name="vendedorId" margin required={!!camposObligatorios.vendedorId} label="Vendedor"  fieldKey="vendedorId"labelCol={{ span: 7 }} wrapperCol={{ span: 16 }}>
                            <SelectItem>
                              {this.state.objetoVendedores}
                            </SelectItem>
                          </FormItem>

                          <FormItem name="canalDeVentaId" margin label="Canal" fieldKey="canalDeVentaId" labelCol={{ span: 7 }} wrapperCol={{ span: 16 }}>
                            <SelectItem placeholder="Canal" allowClear>
                              {this.state.objetoCanalesVenta}
                            </SelectItem>
                          </FormItem>

                          <FormItem name="contado" margin label="Método Pago" labelCol={{ span: 7 }} wrapperCol={{ span: 16 }} initialValue={1}>
                            <SelectItem width="100%" disabled={!this.props.permisoModificarParametosDeCredito}>
                                <Option value={1}>
                                    Contado - PUE : Pago en una sola exhibición
                                </Option>
                                <Option value={2}>
                                    Crédito - PPD : Pago en parcialidades o
                                    diferido
                                </Option>
                            </SelectItem>
                          </FormItem> 

                            <FormItem
                                name="bancoId"
                                fieldKey="bancoId"
                                label="Banco"
                                margin
                                required={!!camposObligatorios.bancoId}
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 16 }}
                             >
                                <SelectItem placeholder="Banco">
                                    {this.state.objetoBancos}
                                </SelectItem>
                           </FormItem>

                            <FormItem
                                name="formaDePagoId"
                                fieldKey="formaDePagoId"
                                label="Forma de Pago"
                                margin
                                required={!!camposObligatorios.formaDePagoId}
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 16 }}
                                tooltip={ "Forma de pago predeterminada para el cliente."}
                                >

                                <SelectItem placeholder="Forma de Pago">
                                    {this.state.objetoFormasDePago}
                                </SelectItem>

                             </FormItem>

                            <FormItem
                                name="monedaId"
                                fieldKey="monedaId"
                                label="Moneda"
                                margin
                                required={!!camposObligatorios.monedaId}
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 16 }}
                                tooltip={"Moneda predeterminada para el cliente."}
                                >

                                <SelectItem placeholder="Moneda">
                                    {this.state.objetoMonedas}
                                </SelectItem>

                             </FormItem>

                            <Row gutter={[8, 0]}>
                              <Col span={12}>
                                <FormItem name="diasCredito" margin required={!!camposObligatorios.diasCredito} label="Días crédito"labelCol={{ span: 14 }} wrapperCol={{ span: 10 }}>
                                 
                                    <InputNumberItem disabled={!this.props.permisoModificarParametosDeCredito} />                              
                                </FormItem>
                                <FormItem name="limiteCredito" margin required={!!camposObligatorios.limiteCredito} label="Crédito" labelCol={{ span: 14 }} wrapperCol={{ span: 10 }}>
                                 <InputNumberItem dinero disabled={!this.props.permisoModificarParametosDeCredito} />
                                  
                                </FormItem>
                                <FormItem name="limiteDescuento" margin required={!!camposObligatorios.limiteDescuento} label="Desc Máx. %" labelCol={{ span: 14 }} wrapperCol={{ span: 10 }}>
                                   <InputNumberItem porcentaje disabled={!this.props.permisoModificarParametosDeCredito} />
                                </FormItem>
                                {this.props.escuela && (
                                  <FormItem name="descuentoPredeterminado" margin label="Desc. Predet. %" labelCol={{ span: 14 }} wrapperCol={{ span: 10 }} tooltip="Se precarga como Desc. Cliente en cada renglón de ventas, pedidos, cotizaciones y embarques. En cada operación se le puede sumar un descuento adicional (en cascada).">
                                    <InputNumberItem porcentaje max={100} disabled={!this.props.permisoModificarParametosDeCredito} />
                                  </FormItem>
                                )}
                              </Col>

                              <Col span={12}>
                                <FormItem name="precioContadoId"  fieldKey={"precioContadoId"} margin required={!!camposObligatorios.precioContadoId || esEmpresaEspecial} label="P. Contado" labelCol={{ span: 9 }} wrapperCol={{ span: 13 }}>
                                   <SelectItem placeholder="Precio Contado" disabled={!this.props.permisoModificarParametosDeCredito}>
                                        {this.state.objetoPrecios}
                                    </SelectItem>
                                </FormItem>
                                <FormItem name="precioCreditoId"   fieldKey={"precioCreditoId"} margin required={!!camposObligatorios.precioCreditoId} label="P. Crédito" labelCol={{ span: 9 }} wrapperCol={{ span: 13 }}>
                                    <SelectItem placeholder="Precio Credito" disabled={!this.props.permisoModificarParametosDeCredito}>
                                        {this.state.objetoPrecios}
                                    </SelectItem>
                                </FormItem>
                                <FormItem name="precioOnlineId"   fieldKey={"precioOnlineId"} margin label="P. E-Commerce" labelCol={{ span: 9 }} wrapperCol={{ span: 13 }} tooltip="Lista de precios que verá este cliente en la tienda en línea. Vacío usa la del tipo de cliente.">
                                    <SelectItem placeholder="Usar la del tipo de cliente" allowClear disabled={!this.props.permisoModificarParametosDeCredito}>
                                        {this.state.objetoPrecios}
                                    </SelectItem>
                                </FormItem>
                              </Col>
                            </Row>
                            <Col span={24}>
                                <FormItem
                                    name="leyenda"
                                    label="Leyenda"
                                    required={!!camposObligatorios.leyenda}
                                    rules={!!camposObligatorios.leyenda ? [{ validator: (_, v) => v ? Promise.resolve() : Promise.reject(new Error('Debes activar Leyenda')) }] : []}
                                    valuePropName="checked"
                                    initialValue={false}
                                    margin
                                    labelCol={{ span: 7}}
                                    wrapperCol={{ span: 14 }}
                                >
                                    <Checkbox />
                                </FormItem>
                            </Col>

                           <Col span={24}>
                            <FormItem name="clienteDePortal" label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Cliente Portal</span>} margin required={!!camposObligatorios.clienteDePortal} rules={!!camposObligatorios.clienteDePortal ? [{ validator: (_, v) => v ? Promise.resolve() : Promise.reject(new Error('Debes activar Cliente Portal')) }] : []} tooltip='Al activarse el cliente estará disponible en la sección de "Portal Clientes" para tener un seguimiendo de sus facturas.' valuePropName="checked" initialValue={false} labelCol={{ span: 7 }} wrapperCol={{ span: 14 }}>
                              <Checkbox />
                            </FormItem>
                          </Col>

                          <FormItem shouldUpdate={(prevValues, curValues) => prevValues.clienteDePortal !== curValues.clienteDePortal} noStyle>
                            {({ getFieldValue }) =>
                              getFieldValue("clienteDePortal") && (
                                <Col span={24}>
                                  <FormItem name="sinFechaVencimiento" label="Sin Fecha de Vencimiento" margin tooltip='Al activarse, las ventas de este cliente se crean sin fecha de vencimiento ni fecha probable de pago.' valuePropName="checked" initialValue={false} labelCol={{ span: 7 }} wrapperCol={{ span: 14 }}>
                                    <Checkbox />
                                  </FormItem>
                                </Col>
                              )
                            }
                          </FormItem>

                        </DynamicCardForm>
                      </Col>

                    </Row>
                 
                      </>
                    ),
                  },
                  {
                    key: '2',
                    label: 'Contacto',
                    forceRender: true,
                    customContent: (
                      <>
                        <Row gutter={16}>
                          <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                            <DynamicCardForm title={<span>Correos Adicionales</span>}>
                              <FormInitial.List name="correosAdicionales">
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.map(({ name }, arrayKey) => (
                                      <Row key={arrayKey} gutter={8} align="middle">
                                        <Col span={22} xs={22} sm={22} lg={22} xl={22}>
                                          <FormItem
                                            name={[name, "correo"]}
                                            fieldKey={[arrayKey, "correo"]}
                                            required
                                            margin
                                            noStyle
                                            email
                                            pattern
                                          >
                                            <InputItem placeholder="Correo" />
                                          </FormItem>
                                        </Col>
                                        <Col span={2} xs={2} sm={2} lg={2} xl={2}>
                                           <div style={{ textAlign: 'center' }}>
                                              <ButtonItem
                                                rojo2
                                                icon={<DeleteOutlined />}
                                                onClick={() => remove(name)}
                  
                                                lessTime
                                              />
                                            </div>
                                        </Col>
                                      </Row>
                                    ))}
                                    {fields.length < 5 ? (
                                      <div style={{ textAlign: "center", marginTop: 20 }}>
                                        <ButtonItem
                                          type="primary"
                                          onClick={() => add()}
                                          icon={<PlusOutlined />}
                                          cyan
                                        >
                                          Agregar
                                        </ButtonItem>
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </FormInitial.List>
                            </DynamicCardForm>
                          </Col>
                          <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                            <DynamicCardForm title={<span>Datos de Contacto</span>}>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Nombre"
                                    name="nombreContacto"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 19 }}
                                  >
                                    <InputItem placeholder="Nombre de Contacto" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <FormItem
                                    label="Teléfono"
                                    name="telefonoContacto"
                                    number
                                    margin
                                    labelCol={{ lg: { span: 8 }, xl: { span: 8 }, xs: { span: 5 } }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <InputNumberItem
                                      placeholder="Teléfono de Contacto"
                                      celular
                                    />
                                  </FormItem>
                                </Col>
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <FormItem
                                    label="Correo"
                                    name="correoContacto"
                                    pattern
                                    max={200}
                                    email
                                    margin
                                    labelCol={{ lg: { span: 6 }, xl: { span: 6 }, xs: { span: 5 } }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <InputItem placeholder="Correo de Contacto" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Personas pedidos</span>}
                                    name="personasPedidos"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 19 }}
                                  >
                                    <InputItem placeholder="Personas que atienden pedidos" />
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>
                          </Col>
                        </Row>
                      </>
                    ),
                  },
                  {
                    key: '3',
                    label: 'Retenciones',
                    forceRender: true,
                    customContent: (
                      <>
                        <Row gutter={16}>
                          <Col span={24}>
                            <DynamicCardForm title={<span>Retenciones</span>}>
                              <FormInitial.List name="retenciones">
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.map(({ name }, arrayKey) => (
                                      <Row key={arrayKey} gutter={8} align="middle">
                                        <Col span={22} xs={22} sm={22} lg={22} xl={22}>
                                          <FormItem
                                            name={[name, "retencionId"]}
                                            fieldKey={[arrayKey, "retencionId"]}
                                            required
                                            margin
                                            noStyle
                                          >
                                            <SelectItem
                                              width="100%"
                                              placeholder="Retención"
                                            >
                                              {this.state.objetoRetenciones}
                                            </SelectItem>
                                          </FormItem>
                                        </Col>
                                        <Col span={2} xs={2} sm={2} lg={2} xl={2}>
                                           <div style={{ textAlign: 'center' }}>
                                              <ButtonItem
                                                rojo2
                                                icon={<DeleteOutlined />}
                                                onClick={() => remove(name)}
                  
                                                lessTime
                                              />
                                            </div>
                                        </Col>
                                      </Row>
                                    ))}
                                    <div style={{ textAlign: "center", marginTop: 20 }}>
                                      <ButtonItem
                                        type="primary"
                                        cyan
                                        onClick={() => add()}
                                        icon={<PlusOutlined />}
                                      >
                                        Agregar
                                      </ButtonItem>
                                    </div>
                                  </>
                                )}
                              </FormInitial.List>
                            </DynamicCardForm>
                          </Col>
                        </Row>
                      </>
                    ),
                  },
                  {
                    key: '4',
                    label: 'Direcciones',
                    forceRender: true,
                    customContent: (
                      <>
                  <FormInitial.List name="direcciones">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(
                          ({ key, name, fieldKey, ...restField }, arrayKey) => (
                            <React.Fragment key={key}>
                              {arrayKey === 0 && (
                                <div
                                  style={{
                                    padding: "16px",
                                    textAlign: "center",
                                  }}
                                >
                                  <Row gutter={16}>
                                    <Col span={24}>
                                      <h2
                                        style={{
                                          color: "#556B2F",
                                          marginBottom: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        Dirección de Facturación
                                      </h2>

                                      <p
                                        style={{
                                          margin: 0,
                                          textAlign: "center",
                                          marginBottom: "30px",
                                        }}
                                      >
                                        Campos necesarios para facturación
                                      </p>
                                    </Col>
                                  </Row>
                                </div>
                              )}
                              <div className="card-punteada">
                              <Row gutter={16}>
                                <Col span={13} xs={24} lg={13} xl={13}>
                                 <DynamicCardForm title={<span>Dirección {arrayKey + 1}</span>}>
                                    <Row gutter={[16, 0]}>
                                        <Col span={24}>
                                          <FormItem
                                            shouldUpdate={(prev, cur) => prev.rfc !== cur.rfc}
                                            noStyle
                                          >
                                            {({ getFieldValue }) =>
                                              getFieldValue("rfc") === "XEXX010101000" && (
                                                <Row gutter={[16, 0]}>
                                                  <Col xs={24} md={12} lg={12}>
                                                    <FormItem
                                                      {...restField}
                                                      name={[name, "clienteNombre"]}
                                                      fieldKey={[fieldKey, "clienteNombre"]}
                                                      label="Cliente"
                                                      margin
                                                      pattern
                                                      max={200}
                                                      labelCol={{ span: 6 }}
                                                      wrapperCol={{ span: 16 }}
                                                      tooltip="Nombre del cliente para esta dirección (extranjero)"
                                                    >
                                                      <InputItem placeholder="Ej: ACME EUROPE B.V." />
                                                    </FormItem>
                                                  </Col>
                                                  <Col xs={24} md={12} lg={12}>
                                                    <FormItem
                                                      {...restField}
                                                      name={[name, "clienteRfc"]}
                                                      fieldKey={[fieldKey, "clienteRfc"]}
                                                      label="RFC"
                                                      margin
                                                      pattern
                                                      max={50}
                                                      labelCol={{ span: 6 }}
                                                      wrapperCol={{ span: 16 }}
                                                      tooltip="RFC / Tax ID del cliente para esta dirección"
                                                    >
                                                      <InputItem placeholder="Ej: NL000111222B01" />
                                                    </FormItem>
                                                  </Col>
                                                  {arrayKey === 0 && (
                                                    <Col span={24}>
                                                      <FormItem
                                                        {...restField}
                                                        name={[name, "direccionExtranjera"]}
                                                        fieldKey={[fieldKey, "direccionExtranjera"]}
                                                        label="Dirección (extranjero)"
                                                        margin
                                                        pattern
                                                        max={300}
                                                        labelCol={{ span: 6 }}
                                                        wrapperCol={{ span: 16 }}
                                                        tooltip="Domicilio en texto libre para clientes extranjeros. Es lo que se imprime en la factura. Los saltos de linea se respetan en el PDF."
                                                      >
                                                        <TextAreaItem
                                                          rows={3}
                                                          placeholder={"Ej:\nKeizersgracht 123\n1015 CJ Amsterdam\nNetherlands"}
                                                        />
                                                      </FormItem>
                                                    </Col>
                                                  )}
                                                </Row>
                                              )
                                            }
                                          </FormItem>

                                        
                                        </Col>
                                    </Row>
                                    <Row gutter={[16, 0]}>
                                      <Col span={24}>
                                        <FormItem
                                          {...restField}
                                          name={[name, "referencia"]}
                                          fieldKey={[fieldKey, "referencia"]}
                                          label="Referencia"
                                          max={50}
                                          margin
                                          pattern
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                          tooltip={{
                                            title:
                                              "Referencia de la dirección, ejemplo: CUARTO1, C1, etc",
                                          }}
                                        >
                                          <InputItem placeholder="Refencia de la dirección" />
                                        </FormItem>
                                      </Col>
                                    </Row>

                                    <FormItem
                                      shouldUpdate={(prevValues, curValues) =>
                                        prevValues.usarAdenda !== curValues.usarAdenda ||
                                        prevValues.adendaActiva !== curValues.adendaActiva
                                      }
                                      noStyle
                                    >
                                      {({ getFieldValue }) => {
                                        const usaAdenda = getFieldValue("usarAdenda");
                                        const esMabe = getFieldValue("adendaActiva") === "Mabe";
                                        return (
                                          (usaAdenda && esMabe) && (
                                            <Row gutter={[16, 0]}>
                                              <Col span={24}>
                                                <FormItem
                                                  {...restField}
                                                  name={[name, "plantaEntregaId"]}
                                                  fieldKey={[fieldKey, "plantaEntregaId"]}
                                                  label="Planta de Entrega"
                                                  margin
                                                  labelCol={{ span: 6 }}
                                                  wrapperCol={{ span: 14 }}
                                                >
                                                  <SelectItem
                                                    placeholder="Seleccionar planta de entrega"
                                                    showSearch
                                                    filterOption={false}
                                                    mostrarCarga
                                                    loading={
                                                      this.state.loadingPlantasEntrega?.[fieldKey]
                                                    }
                                                    notFoundContent={
                                                      this.state.loadingPlantasEntrega?.[fieldKey]
                                                        ? "Buscando...."
                                                        : "Sin resultados"
                                                    }
                                                    onSearch={(val) =>
                                                      this.onSearchPlantaEntrega(val, fieldKey)
                                                    }
                                                    onFocus={() =>
                                                      this.onSearchPlantaEntrega("", fieldKey)
                                                    }
                                                  >
                                                    {!this.state.objetoPlantasEntrega?.[fieldKey] ||
                                                    this.state.objetoPlantasEntrega[fieldKey]
                                                      .length === 0 ? (
                                                      <Option disabled>
                                                        Escribe ID o Centro de Distribución
                                                      </Option>
                                                    ) : (
                                                      this.state.objetoPlantasEntrega[fieldKey]
                                                    )}
                                                  </SelectItem>
                                                </FormItem>
                                              </Col>
                                            </Row>
                                          )
                                        );
                                      }}
                                    </FormItem>

                                    <Row gutter={[16, 0]}>
                                      <Col span={24}>
                                        <FormItem
                                          label="Calle"
                                          margin
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <Row gutter={8}>
                                            <Col span={14}>
                                              <FormItem
                                                {...restField}
                                                name={[name, "calle"]}
                                                fieldKey={[fieldKey, "calle"]}
                                                max={200}
                                                pattern
                                                noStyle
                                              >
                                                <InputItem placeholder="Calle" />
                                              </FormItem>
                                            </Col>
                                            <Col span={5}>
                                              <FormItem
                                                {...restField}
                                                name={[name, "numeroCalle"]}
                                                fieldKey={[fieldKey, "numeroCalle"]}
                                                noStyle
                                              >
                                                <InputItem placeholder="Número" numeroCalle />
                                              </FormItem>
                                            </Col>
                                            <Col span={5}>
                                              <FormItem
                                                name={[name, "numeroInterior"]}
                                                fieldKey={[fieldKey, "numeroInterior"]}
                                                pattern
                                                noStyle
                                              >
                                                <InputItem placeholder="Interior" />
                                              </FormItem>
                                            </Col>
                                          </Row>
                                        </FormItem>
                                      </Col>
                                    </Row>

                                    <Row gutter={[16, 0]}>
                                      <Col span={24}>
                                        <FormItem
                                          {...restField}
                                          name={[name, "coloniaId"]}
                                          fieldKey={[fieldKey, "coloniaId"]}
                                          label="C.P."
                                          margin
                                          required={arrayKey === 0}
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <SelectItem
                                            placeholder="Código Postal"
                                            onDropdownVisibleChange={() => {
                                              if (
                                                React.Children.count(
                                                  this.state.objetoColonias[fieldKey]
                                                ) === 1
                                              ) {
                                                let direcciones =
                                                  this.formRef.current.getFieldValue(
                                                    "direcciones"
                                                  );
                                                this.onChangeMunicipio(
                                                  direcciones[fieldKey].municipioId,
                                                  fieldKey,
                                                  true
                                                );
                                              }
                                            }}
                                            onSearch={(coloniaId) => {
                                              this.onSearchColonia(coloniaId, arrayKey);
                                            }}
                                            onSelect={(coloniaId) => {
                                              this.onSelectColoniaId(coloniaId, arrayKey);
                                            }}
                                          >
                                            {!this.state.objetoColonias[fieldKey] ? (
                                              <Option disabled>
                                                Eliga primero un municipio
                                              </Option>
                                            ) : (
                                              this.state.objetoColonias[fieldKey]
                                            )}
                                            <Option disabled>
                                              Busque por codigo postal
                                            </Option>
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                    </Row>

                                    <Row gutter={[16, 0]}>
                                      <Col span={24}>
                                        <FormItem
                                          {...restField}
                                          name={[name, "colonia"]}
                                          fieldKey={[fieldKey, "colonia"]}
                                          label="Colonia"
                                          margin
                                          pattern
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputItem placeholder="Colonia" />
                                        </FormItem>
                                      </Col>
                                    </Row>

                                    <Row gutter={[16, 0]}>
                                      <Col span={24}>
                                        <FormItem
                                          {...restField}
                                          name={[name, "paisId"]}
                                          fieldKey={[fieldKey, "paisId"]}
                                          label="País"
                                          margin
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <SelectItem placeholder="País">
                                            {this.state.objetoPaises}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col span={24}>
                                        <FormItem
                                          {...restField}
                                          name={[name, "estadoId"]}
                                          fieldKey={[fieldKey, "estadoId"]}
                                          label="Estado"
                                          margin
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <SelectItem
                                            placeholder="Estado"
                                            onChange={(e) => this.onChangeEstado(e, fieldKey)}
                                          >
                                            {this.state.objetoEstados}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col span={24}>
                                        <FormItem
                                          {...restField}
                                          name={[name, "municipioId"]}
                                          fieldKey={[fieldKey, "municipioId"]}
                                          label="Municipio"
                                          margin
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <SelectItem
                                            placeholder="Municipio"
                                            onDropdownVisibleChange={() => {
                                              if (
                                                React.Children.count(
                                                  this.state.objetoMunicipios[fieldKey]
                                                ) === 1
                                              ) {
                                                let direcciones =
                                                  this.formRef.current.getFieldValue(
                                                    "direcciones"
                                                  );
                                                this.onChangeEstado(
                                                  direcciones[fieldKey].estadoId,
                                                  fieldKey,
                                                  true
                                                );
                                              }
                                            }}
                                            onChange={(e) => this.onChangeMunicipio(e, fieldKey)}
                                          >
                                            {!this.state.objetoMunicipios[fieldKey] ? (
                                              <Option disabled>
                                                Elija primero un estado
                                              </Option>
                                            ) : (
                                              this.state.objetoMunicipios[fieldKey]
                                            )}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                    </Row>
                                  </DynamicCardForm>
                                </Col>

                                <Col span={11} xs={24} sm={24} lg={11} xl={11}>
                                  <DynamicCardForm title={<span>Contacto en Dirección</span>}>
                                    <Row gutter={[16, 0]}>
                                      <Col span={24}>
                                        <FormItem
                                          {...restField}
                                          name={[name, "descripcion"]}
                                          fieldKey={[fieldKey, "descripcion"]}
                                          label="Contacto"
                                          margin
                                          pattern
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputItem placeholder="Contacto" />
                                        </FormItem>
                                      </Col>
                                    </Row>

                                    <Row gutter={[16, 0]}>
                                      <Col span={24}>
                                        <FormItem
                                          label="Teléfono"
                                          name={[name, "telefono"]}
                                          fieldKey={[fieldKey, "telefono"]}
                                          number
                                          margin
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputNumberItem placeholder="Teléfono" celular />
                                        </FormItem>
                                      </Col>
                                    </Row>

                                    <Row gutter={[16, 0]}>
                                      <Col span={24}>
                                        <FormItem
                                          label="Correo"
                                          name={[name, "correo"]}
                                          fieldKey={[fieldKey, "correo"]}
                                          pattern
                                          max={200}
                                          email
                                          margin
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputItem placeholder="Correo" />
                                        </FormItem>
                                      </Col>
                                    </Row>

                                    <Row gutter={[16, 0]}>
                                      <Col span={24}>
                                        <FormItem
                                          {...restField}
                                          name={[name, "observaciones"]}
                                          fieldKey={[fieldKey, "observaciones"]}
                                          label="Observaciones"
                                          margin
                                          pattern
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputItem placeholder="Notas adicionales" />
                                        </FormItem>
                                      </Col>
                                    </Row>

                                  </DynamicCardForm>
                                </Col>
                              </Row>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  marginTop: "12px",
                                }}
                              >
                                <ButtonItem
                                  type="primary"
                                  danger
                                  onClick={() => remove(name)}
                                >
                                  Eliminar Dirección
                                </ButtonItem>
                              </div>
                              </div>
                            </React.Fragment>
                          )
                        )}
                        <FormItem noStyle>
                          <ButtonItem
                            style={{ marginTop: 10, marginBottom: 10 }}
                            type="dashed"
                            onClick={() => add()}
                            block
                            cyan
                            icon={<PlusOutlined />}
                          >
                            Agregar Dirección
                          </ButtonItem>
                        </FormItem>
                      </>
                    )}
                  </FormInitial.List>
                      </>
                    ),
                  },
                  ...((this.state.mercanciasEnvio || this.props.fletes) ? [{
                    key: '8',
                    label: 'Mercancías',
                    forceRender: true,
                    customContent: (
                      <>
                        <Spin spinning={this.state.loadingMercancias}>
                          <FormInitial.List name="mercanciasEnvio">
                            {(fields, { add, remove }) => (
                              <>
                                {fields.map(
                                  ({ key, name, fieldKey, ...restField }, arrayKey) => (
                                    <div
                                      key={key}
                                      style={{
                                        background: '#efefef2d',
                                        border: '1px solid #c7c7c7',
                                        borderRadius: 10,
                                        padding: 16,
                                        marginBottom: 20,
                                        boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.08)',
                                        position: 'relative',
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                          marginBottom: 14,
                                          paddingBottom: 8,
                                          borderBottom: '2px solid #00BFD6',
                                          gap: 12,
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: 16,
                                            fontWeight: 800,
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            color: '#00BFD6',
                                          }}
                                        >
                                          INSUMO {arrayKey + 1}
                                        </span>
                                        <Popconfirm
                                          title="¿Eliminar esta mercancía?"
                                          okText="Eliminar"
                                          cancelText="Cancelar"
                                          onConfirm={() => remove(name)}
                                        >
                                          <ButtonItem
                                            danger
                                            icon={<DeleteOutlined />}
                                            lessTime
                                          >
                                            Eliminar Mercancía
                                          </ButtonItem>
                                          
                                        </Popconfirm>
                                      </div>

                                      <Row gutter={[16, 0]}>
                                        {/* ===================== GENERALES ===================== */}
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                          <DynamicCardForm title={<span>Generales</span>}>
                                            <Row gutter={[8, 0]}>
                                              <Col xs={24} sm={24} md={12} lg={24} xl={12}>
                                                <FormItem
                                                  label="Descripción"
                                                  {...restField}
                                                  name={[name, "descripcion"]}
                                                  fieldKey={[arrayKey, "descripcion"]}
                                                  required
                                                  margin
                                                  labelCol={{ span: 8 }}
                                                  wrapperCol={{ span: 16 }}
                                                  pattern
                                                >
                                                  <InputItem placeholder="Descripción" />
                                                </FormItem>
                                              </Col>
                                              <Col xs={24} sm={24} md={12} lg={24} xl={12}>
                                                <FormItem
                                                  label="Unidad"
                                                  margin
                                                  labelCol={{ span: 8 }}
                                                  wrapperCol={{ span: 16 }}
                                                >
                                                  <Input.Group compact>
                                                    <FormItem
                                                      {...restField}
                                                      name={[name, "unidadId"]}
                                                      fieldKey={[arrayKey, "unidadId"]}
                                                      required
                                                      noStyle
                                                    >
                                                      <SelectItem
                                                        placeholder="Unidad"
                                                        width="70%"
                                                      >
                                                        {this.state.objetoUnidades}
                                                      </SelectItem>
                                                    </FormItem>
                                                    <ButtonItem
                                                      icon={<PlusOutlined />}
                                                      style={{ width: "12%" }}
                                                      cyan
                                                      onClick={this.abrirAgregarUnidad.bind(this)}
                                                    />
                                                  </Input.Group>
                                                </FormItem>
                                              </Col>
                                            </Row>
                                            <Row gutter={[8, 0]}>
                                              <Col xs={24} sm={24} md={12} lg={24} xl={12}>
                                                <FormItem
                                                  label="Valor"
                                                  {...restField}
                                                  name={[name, "valorMercancia"]}
                                                  fieldKey={[arrayKey, "valorMercancia"]}
                                                  required
                                                  margin
                                                  labelCol={{ span: 8 }}
                                                  wrapperCol={{ span: 16 }}
                                                  numberCero
                                                >
                                                  <InputNumberItem
                                                    placeholder="Valor Mercancia"
                                                    dinero
                                                  />
                                                </FormItem>
                                              </Col>
                                              <Col xs={24} sm={24} md={12} lg={24} xl={12}>
                                                <FormItem
                                                  label="Peso en KGM"
                                                  {...restField}
                                                  name={[name, "pesoEnKGM"]}
                                                  fieldKey={[arrayKey, "pesoEnKGM"]}
                                                  margin
                                                  labelCol={{ span: 8 }}
                                                  wrapperCol={{ span: 13 }}
                                                  numberCero
                                                >
                                                  <InputNumberItem placeholder="Peso en KGM" />
                                                </FormItem>
                                              </Col>
                                            </Row>
                                              <Row>
                                                <Col
                                                  span={19}
                                                  xs={19}
                                                  sm={19}
                                                  lg={19}
                                                  xl={19}
                                                >
                                                <FormItem
                                                  label="Codigo Sat"
                                                  {...restField}
                                                  name={[name, "codigoSatId"]}
                                                  fieldKey={[arrayKey, "codigoSatId"]}
                                                  required
                                                  margin
                                                  labelCol={{ span: 5 }}
                                                  wrapperCol={{ span: 19 }}
                                                >
                                                  <SelectItem
                                                    mostrarCarga
                                                    loading={
                                                      this.state.buscarInfoCodes[arrayKey]
                                                        ? this.state.buscarInfoCodes[arrayKey]
                                                        : false
                                                    }
                                                    placeholder="Codigo Sat"
                                                    onSearch={(value) => {
                                                      this.onChangeCodigo(value, arrayKey);
                                                    }}
                                                  >
                                                    <Option disabled>
                                                      Escriba para buscar el codigo
                                                    </Option>
                                                    {this.state.objetoCodigosSat[arrayKey]
                                                      ? this.state.objetoCodigosSat[arrayKey]
                                                      : null}
                                                  </SelectItem>
                                                </FormItem>
                                              </Col>
                                              <Col span={5} xs={5} sm={5} md={5} lg={5} xl={5} style={{ paddingBottom: 8 }}>
                                                <ButtonItem
                                                  cyan
                                                  size="small"
                                                  style={{ width: '70%', fontSize: 14 }}
                                                    onClick={() =>
                                                      window.open(
                                                        "http://pys.sat.gob.mx/PyS/catPyS.aspx",
                                                        "_blank"
                                                      )
                                                  }
                                                >
                                                  Conoce tu codigo sat
                                                </ButtonItem>
                                              </Col>
           
                                            </Row>
                                          </DynamicCardForm>
                                        </Col>

                                        {/* ===================== DATOS MERCANCIA ===================== */}
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                          <DynamicCardForm title={<span>Datos Mercancía</span>}>
                                            <Row gutter={[8, 0]}>
                                              <Col xs={24} sm={24} md={12} lg={24} xl={12}>
                                                <FormItem
                                                  {...restField}
                                                  name={[name, "dimensiones"]}
                                                  fieldKey={[arrayKey, "dimensiones"]}
                                                  label="Dimensiones"
                                                  margin
                                                  labelCol={{ span: 8 }}
                                                  wrapperCol={{ span: 16 }}
                                                  pattern
                                                >
                                                  <InputItem placeholder="Ejemplo: 59/40/36plg" />
                                                </FormItem>
                                                <FormItem
                                                  label="Descripcion Materia"
                                                  {...restField}
                                                  name={[name, "descripcionMateria"]}
                                                  fieldKey={[arrayKey, "descripcionMateria"]}
                                                  margin
                                                  pattern
                                                  labelCol={{ span: 8 }}
                                                  wrapperCol={{ span: 16 }}
                                                  tooltip={{
                                                    title:
                                                      "Atributo opcional para expresar la clave de producto de la STCC (por sus siglas en inglés, Standard Transportation Commodity Code), cuando el medio de transporte utilizado para el traslado de los bienes y/o mercancías sea ferroviario.",
                                                  }}
                                                >
                                                  <InputItem placeholder="Descripcion Materia" />
                                                </FormItem>
                                                <FormItem
                                                  label="Material Peligroso"
                                                  {...restField}
                                                  name={[name, "materialPeligroso"]}
                                                  fieldKey={[arrayKey, "materialPeligroso"]}
                                                  margin
                                                  initialValue={false}
                                                  valuePropName="checked"
                                                  labelCol={{ span: 8 }}
                                                  wrapperCol={{ span: 16 }}
                                                >
                                                  <SwitchItem />
                                                </FormItem>
                                                <FormItem shouldUpdate noStyle>
                                                  {({ getFieldValue }) => {
                                                    if (getFieldValue("materialPeligroso")) {
                                                      return (
                                                        <>
                                                          <FormItem
                                                            label="Material Peligroso"
                                                            {...restField}
                                                            name={[name, "materialPeligrosoId"]}
                                                            fieldKey={[arrayKey, "materialPeligrosoId"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            required
                                                          >
                                                            <SelectItem
                                                              placeholder="Material Peligroso"
                                                              width="100%"
                                                            >
                                                              {this.state.objetoMaterialesPeligrosos}
                                                            </SelectItem>
                                                          </FormItem>
                                                          <FormItem
                                                            label="Numero CAS"
                                                            {...restField}
                                                            name={[name, "numCAS"]}
                                                            fieldKey={[arrayKey, "numCAS"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para expresar el número Chemical Abstracts Service (CAS) con el que se identifica el compuesto químico de la sustancia tóxica.",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Numero CAS" />
                                                          </FormItem>
                                                        </>
                                                      );
                                                    }
                                                  }}
                                                </FormItem>
                                              </Col>
                                              <Col xs={24} sm={24} md={12} lg={24} xl={12}>
                                                <FormItem
                                                  label="Clave STCC"
                                                  {...restField}
                                                  name={[name, "claveSTCC"]}
                                                  fieldKey={[arrayKey, "claveSTCC"]}
                                                  margin
                                                  labelCol={{ span: 8 }}
                                                  wrapperCol={{ span: 16 }}
                                                  numberCero
                                                  tooltip={{
                                                    title:
                                                      "Atributo opcional para expresar la clave de producto de la STCC (por sus siglas en inglés, Standard Transportation Commodity Code), cuando el medio de transporte utilizado para el traslado de los bienes y/o mercancías sea ferroviario.",
                                                  }}
                                                >
                                                  <InputNumberItem placeholder="Clave STCC" />
                                                </FormItem>
                                                <FormItem
                                                  label="Tipo Materia"
                                                  {...restField}
                                                  name={[name, "tipoMateriaId"]}
                                                  fieldKey={[arrayKey, "tipoMateriaId"]}
                                                  margin
                                                  labelCol={{ span: 8 }}
                                                  wrapperCol={{ span: 16 }}
                                                  tooltip={{
                                                    title:
                                                      "Atributo condicional para expresar el estado de la materia o producto al realizar una operación de comercio exterior a través de los distintos medios de transporte.",
                                                  }}
                                                >
                                                  <SelectItem
                                                    placeholder="Tipo Materia"
                                                    width="100%"
                                                  >
                                                    {this.state.objetoTiposMaterias}
                                                  </SelectItem>
                                                </FormItem>
                                                <FormItem shouldUpdate noStyle>
                                                  {({ getFieldValue }) => {
                                                    if (getFieldValue("materialPeligroso")) {
                                                      return (
                                                        <>
                                                          <FormItem
                                                            label="Embalaje"
                                                            {...restField}
                                                            name={[name, "embalajeId"]}
                                                            fieldKey={[arrayKey, "embalajeId"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            required
                                                          >
                                                            <SelectItem
                                                              placeholder="Embalaje"
                                                              width="100%"
                                                            >
                                                              {this.state.objetoEmbalajes}
                                                            </SelectItem>
                                                          </FormItem>
                                                          <FormItem
                                                            label="Descripcion Embalaje"
                                                            {...restField}
                                                            name={[name, "descripcionEmbalaje"]}
                                                            fieldKey={[arrayKey, "descripcionEmbalaje"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            required
                                                          >
                                                            <InputItem placeholder="Ejemplo: Cajas de madera contrachapada" />
                                                          </FormItem>
                                                        </>
                                                      );
                                                    }
                                                  }}
                                                </FormItem>
                                              </Col>
                                            </Row>
                                          </DynamicCardForm>
                                        </Col>

                                        {/* ===================== SECTOR COFEPRIS ===================== */}
                                        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                          <DynamicCardForm title={<span>Sector COFEPRIS</span>}>
                                            <Row gutter={[16, 0]}>
                                              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <FormItem
                                                  label="Sector COFEPRIS"
                                                  {...restField}
                                                  name={[name, "sectorCOFEPRIS"]}
                                                  fieldKey={[arrayKey, "sectorCOFEPRIS"]}
                                                  margin
                                                  initialValue={false}
                                                  valuePropName="checked"
                                                  labelCol={{ span: 16}}
                                                  wrapperCol={{ span: 8 }}
                                                >
                                                  <SwitchItem />
                                                </FormItem>
                                                <FormItem shouldUpdate noStyle>
                                                  {({ getFieldValue }) => {
                                                    if (getFieldValue("sectorCOFEPRIS")) {
                                                      return (
                                                        <>
                                                          <FormItem
                                                            label="Sector COFEPRIS"
                                                            {...restField}
                                                            name={[name, "sectorCOFEPRISId"]}
                                                            fieldKey={[arrayKey, "sectorCOFEPRISId"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            required
                                                          >
                                                            <SelectItem
                                                              placeholder="Sector COFEPRIS"
                                                              width="100%"
                                                            >
                                                              {this.state.objetoSectoresCOF}
                                                            </SelectItem>
                                                          </FormItem>
                                                          <FormItem
                                                            label="Ingrediente Activo"
                                                            {...restField}
                                                            name={[name, "nombreIngredienteActivo"]}
                                                            fieldKey={[arrayKey, "nombreIngredienteActivo"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para expresar el nombre común del ingrediente activo de los precursores, químicos de uso dual, plaguicidas o fertilizantes que se trasladan a través de los distintos medios de transporte",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Ingrediente Activo" />
                                                          </FormItem>
                                                          <FormItem
                                                            label="Nombre Quimico"
                                                            {...restField}
                                                            name={[name, "nombreQuimico"]}
                                                            fieldKey={[arrayKey, "nombreQuimico"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                             tooltip={{
                                                            title:
                                                              "Atributo condicional para expresar el nombre de la sustancia activa de los precursores, químicos de uso dual o sustancias tóxicas que se traslada a través de los distintos medios de transporte.",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Nombre Quimico" />
                                                          </FormItem>
                                                          <FormItem
                                                            label="Denominacion Generica"
                                                            {...restField}
                                                            name={[name, "denominacionGenericaProd"]}
                                                            fieldKey={[arrayKey, "denominacionGenericaProd"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para expresar el fármaco o la sustancia activa del medicamento, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte.",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Denominacion Generica" />
                                                          </FormItem>
                                                          <FormItem
                                                            label="Denominacion Distintiva"
                                                            {...restField}
                                                            name={[name, "denominacionDistintivaProd"]}
                                                            fieldKey={[arrayKey, "denominacionDistintivaProd"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para expresar la marca con la que se comercializa el producto o nombre que le asigna el laboratorio o fabricante a sus especialidades farmacéuticas con el fin de distinguirlas de otras similares del medicamento, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte.",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Denominacion Distintiva" />
                                                          </FormItem>
                                                        </>
                                                      );
                                                    }
                                                  }}
                                                </FormItem>
                                              </Col>
                                              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <FormItem shouldUpdate noStyle>
                                                  {({ getFieldValue }) => {
                                                    if (getFieldValue("sectorCOFEPRIS")) {
                                                      return (
                                                        <>
                                                          <FormItem
                                                            label="Fabricante"
                                                            {...restField}
                                                            name={[name, "fabricante"]}
                                                            fieldKey={[arrayKey, "fabricante"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para expresar el nombre o razón social del establecimiento que realiza la fabricación o manufactura del medicamento, precursor, químico de uso dual, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte.",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Fabricante" />
                                                          </FormItem>
                                                          <FormItem
                                                            label="Forma Farmaceutica"
                                                            {...restField}
                                                            name={[name, "formaFarmaceuticaId"]}
                                                            fieldKey={[arrayKey, "formaFarmaceuticaId"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                          >
                                                            <SelectItem
                                                              placeholder="Forma Farmaceutica"
                                                              width="100%"
                                                            >
                                                              {this.state.objetoFormasFarmaceuticas}
                                                            </SelectItem>
                                                          </FormItem>
                                                          <FormItem
                                                            label="Condiciones Especiales"
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para expresar la condición en la cual es necesario mantener el medicamento, precursor, químico de uso dual, psicotrópicos o estupefacientes durante el traslado y almacenamiento.",
                                                            }}
                                                            {...restField}
                                                            name={[name, "condicionEspecialId"]}
                                                            fieldKey={[arrayKey, "condicionEspecialId"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                          >
                                                            <SelectItem
                                                              placeholder="Condiciones Especiales"
                                                              width="100%"
                                                            >
                                                              {this.state.objetoCondicionesEspeciales}
                                                            </SelectItem>
                                                          </FormItem>
                                                          <FormItem
                                                            label="Registro Sanitario"
                                                            {...restField}
                                                            name={[name, "registroSanitarioFolioAutorizacion"]}
                                                            fieldKey={[arrayKey, "registroSanitarioFolioAutorizacion"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para expresar el registro sanitario o folio de autorización con el que cuenta la empresa para el traslado del medicamento, psicotrópico o estupefaciente.",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Registro Sanitario" />
                                                          </FormItem>
                                                          <FormItem
                                                            label="Numero Registro"
                                                            {...restField}
                                                            name={[name, "numRegSanPlagCOFEPRIS"]}
                                                            fieldKey={[arrayKey, "numRegSanPlagCOFEPRIS"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para expresar el número de registro sanitario para plaguicidas o fertilizantes cuya importación, comercialización y uso están permitidos en México, mismo que emite la Comisión Intersecretarial para el Control del Proceso y Uso de Plaguicidas, Fertilizantes y Sustancias Tóxicas (CICLOPLAFEST).",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Numero Registro" />
                                                          </FormItem>
                                                          <FormItem
                                                            label="Datos Fabricante"
                                                            {...restField}
                                                            name={[name, "datosFabricante"]}
                                                            fieldKey={[arrayKey, "datosFabricante"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para registrar el país y nombre o razón social de quien produce o fabrica el ingrediente activo del plaguicida o fertilizante.",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Datos Fabricante" />
                                                          </FormItem>
                                                          <FormItem
                                                            label="Datos Formulador"
                                                            {...restField}
                                                            name={[name, "datosFormulador"]}
                                                            fieldKey={[arrayKey, "datosFormulador"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para registrar el país y nombre o razón social de quien formula el ingrediente activo del plaguicida o fertilizante.",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Datos Formulador" />
                                                          </FormItem>
                                                          <FormItem
                                                            label="Datos Maquilador"
                                                            {...restField}
                                                            name={[name, "datosMaquilador"]}
                                                            fieldKey={[arrayKey, "datosMaquilador"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para registrar el país y nombre o razón social de quien maquila el ingrediente activo del plaguicida o fertilizante.",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Datos Maquilador" />
                                                          </FormItem>
                                                          <FormItem
                                                            label="Uso Autorizado"
                                                            {...restField}
                                                            name={[name, "usoAutorizado"]}
                                                            fieldKey={[arrayKey, "usoAutorizado"]}
                                                            margin
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            pattern
                                                            tooltip={{
                                                              title:
                                                                "Atributo condicional para registrar el uso autorizado del plaguicida o fertilizante de acuerdo a la regulación del país.",
                                                            }}
                                                          >
                                                            <InputItem placeholder="Uso Autorizado" />
                                                          </FormItem>
                                                        </>
                                                      );
                                                    }
                                                  }}
                                                </FormItem>
                                              </Col>
                                            </Row>
                                          </DynamicCardForm>
                                        </Col>

                                        {/* ===================== DETALLE MERCANCIA ===================== */}
                                       <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                          <DynamicCardForm title={<span>Detalle Mercancía</span>}
                                             headerRight={
                                              this.state.unidadPeso ? (
                                                  <p style={{ textAlign: "center" }}>
                                                    Unidad de peso:{" "}
                                                    {this.state.unidadPeso.nombre} -{" "}
                                                    {
                                                      this.state.unidadPeso.unidadSat
                                                        .c_ClaveUnidad
                                                    }
                                                  </p>
                                              ) : null
                                            }
                                          >

                                   
                                            <Row gutter={[16, 0]}>
                                              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                <FormItem
                                                  label="Peso Bruto"
                                                  {...restField}
                                                  name={[name, "pesoBruto"]}
                                                  fieldKey={[arrayKey, "pesoBruto"]}
                                                  margin
                                                  labelCol={{ span: 10 }}
                                                  wrapperCol={{ span: 14 }}
                                                  numberCero
                                                >
                                                  <InputNumberItem placeholder="Peso Bruto" />
                                                </FormItem>
                                              </Col>
                                              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                <FormItem
                                                  label="Peso Neto"
                                                  {...restField}
                                                  name={[name, "pesoNeto"]}
                                                  fieldKey={[arrayKey, "pesoNeto"]}
                                                  margin
                                                  labelCol={{ span: 10 }}
                                                  wrapperCol={{ span: 14 }}
                                                  numberCero
                                                >
                                                  <InputNumberItem placeholder="Peso Neto" />
                                                </FormItem>
                                              </Col>
                                              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                <FormItem
                                                  label="Peso Tara"
                                                  {...restField}
                                                  name={[name, "pesoTara"]}
                                                  fieldKey={[arrayKey, "pesoTara"]}
                                                  margin
                                                  labelCol={{ span: 10 }}
                                                  wrapperCol={{ span: 14 }}
                                                  numberCero
                                                >
                                                  <InputNumberItem placeholder="Peso Tara" />
                                                </FormItem>
                                              </Col>
                                            </Row>
                                          </DynamicCardForm>
                                        </Col>
                                      </Row>
                                    </div>
                                  )
                                )}
                                <FormItem noStyle>
                                  <ButtonItem
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                    type="dashed"
                                    onClick={() => add()}
                                    block
                                    cyan
                                    icon={<PlusOutlined />}
                                  >
                                    Agregar Mercancia
                                  </ButtonItem>
                                </FormItem>
                              </>
                            )}
                          </FormInitial.List>
                        </Spin>
                      </>
                    ),
                  }] : []),
                  {
                    key: '5',
                    label: 'Contabilidad',
                    forceRender: true,
                    customContent: (
                      <>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const tipoDeClienteId = getFieldValue("tipoClienteId");
                            const tipoDeCliente = tipoDeClienteId
                              ? this.state.todasTipoDeCliente.find(
                                (valueTodos) =>
                                  valueTodos._id.toString() ===
                                  tipoDeClienteId.toString()
                              )
                              : null;
                            return (
                              <Row gutter={16}>
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <DynamicCardForm title={<span>Cuentas Cliente</span>}>
                                    <Row>
                                     <Col span={22} xs={22} sm={22} lg={22} xl={22}>
                                        <FormItem
                                          label="Cuenta Cliente"
                                          name="cuentaClienteId"
                                          margin
                                          labelCol={{ span: 7 }}
                                          wrapperCol={{ span: 16 }}
                                          tooltip="Selecciona primero un tipo de cliente"
                                        >
                                          <SelectItem
                                            disabled
                                            placeholder="Cuenta Cliente"
                                            width="100%"
                                          >
                                            {this.state.objetoCuentaContable}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                    </Row>
                                    <Row align="middle">
                                      <Col span={22} xs={22} sm={22} lg={22} xl={22}>
                                        <FormItem
                                          name="cuentaAnticipoId"
                                          label="Cuenta Anticipo"
                                          margin
                                          labelCol={{ span: 7 }}
                                          wrapperCol={{ span: 16 }}
                                          tooltip="Selecciona primero un tipo de cliente"
                                        >
                                          <SelectItem
                                            disabled
                                            placeholder="Cuenta Anticipo"
                                            width="100%"
                                          >
                                            {this.state.objetoCuentaContable}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col span={2} xs={2} sm={2} lg={1} xl={1} style={{ textAlign: "center" }}>
                                        <FormItem
                                          noStyle
                                          name="generarCuentaAnticipoId"
                                          valuePropName="checked"
                                        >
                                          <Checkbox disabled={!tipoDeCliente?.generarCuentasAutomatico || !!this.state?.dataInicial?.cuentaAnticipoId}></Checkbox>
                                        </FormItem>
                                      </Col>
                                    </Row>
                                  </DynamicCardForm>
                                </Col>
                                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                  <DynamicCardForm title={<span>Cuentas Adicionales</span>}>
                                    <Row align="middle">
                                      <Col span={22} xs={22} sm={22} lg={22} xl={22}>
                                        <FormItem
                                          label="Cuenta Fon. Gar."
                                          tooltip="Selecciona primero un tipo de cliente"
                                          margin
                                          name="cuentaFonGarId"
                                          labelCol={{ span: 7 }}
                                          wrapperCol={{ span: 16 }}
                                        >
                                          <SelectItem
                                            disabled
                                            placeholder="Cuenta Fondo de Gararantia"
                                            width="100%"
                                          >
                                            {this.state.objetoCuentaContable}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col span={2} xs={2} sm={2} lg={1} xl={1} style={{ textAlign: "center" }}>
                                        <FormItem
                                          noStyle
                                          name="generarCuentaFonGarId"
                                          valuePropName="checked"
                                          
                                        >
                                          <Checkbox disabled={!tipoDeCliente?.generarCuentasAutomatico || !!this.state?.dataInicial?.cuentaFonGarId}></Checkbox>
                                        </FormItem>
                                      </Col>
                                    </Row>
                                    <Row align="middle">
                                      <Col span={22} xs={22} sm={22} lg={22} xl={22}>
                                        <FormItem
                                          label="Cuenta Acreedor"
                                          name="cuentaDeudorId"
                                          margin
                                          labelCol={{ span: 7 }}
                                          wrapperCol={{ span: 16 }}
                                          tooltip="Selecciona primero un tipo de cliente"
                                        >
                                          <SelectItem
                                            disabled
                                            placeholder="Cuenta Acreedor"
                                            width="100%"
                                          >
                                            {this.state.objetoCuentaContable}
                                          </SelectItem>
                                        </FormItem>
                                      </Col>
                                      <Col span={2} xs={2} sm={2} lg={1} xl={1} style={{ textAlign: "center" }}>
                                        <FormItem
                                          noStyle
                                          name="generarCuentaDeudorId"
                                          valuePropName="checked"
                                        >
                                          <Checkbox disabled={!tipoDeCliente?.generarCuentasAutomatico || !!this.state?.dataInicial?.cuentaDeudorId}></Checkbox>
                                        </FormItem>
                                      </Col>
                                    </Row>
                                  </DynamicCardForm>
                                </Col>
                                {/* Los selects de arriba siguen bloqueados: editarCliente
                                    borra las cuentas del body y nunca reasigna una ya
                                    generada. Mover una cuenta obliga a decidir que pasa
                                    con el saldo que se queda en la anterior, y eso vive
                                    en el modal. */}
                                {this.state.dataInicial?.tipoClienteId ? (
                                  <Col span={24}>
                                    <div style={{ textAlign: "right", marginBottom: 8 }}>
                                      <ButtonItem
                                        type="primary"
                                        blanco
                                        size="small"
                                        onClick={() => this.setState({ modalMoverCuentas: true })}
                                      >
                                        Mover cuentas contables
                                      </ButtonItem>
                                    </div>
                                  </Col>
                                ) : null}
                              </Row>
                            );
                          }}
                        </FormItem>
                      </>
                    ),
                  },
                 ...(this.props.complementoDetallista ? [{
                      key: '7',
                      label: 'Detallista',
                      forceRender: true,
                      customContent: (
                        <>
                          <Row gutter={16}>
                            <Col span={24}>
                              <DynamicCardForm title={<span>Complemento Detallista</span>}>

                                {/* ── Switch principal ── */}
                                <FormItem
                                  label="Activar Complemento Detallista"
                                  name="complementoDetallista"
                                  margin
                                  initialValue={false}
                                  valuePropName="checked"
                                  tooltip="Al activar esta casilla se activa el complemento detallista para este cliente."
                                  labelCol={{ span: 6 }}
                                  wrapperCol={{ span: 18 }}
                                >
                                  <SwitchItem />
                                </FormItem>

                                <FormItem shouldUpdate noStyle>
                                  {({ getFieldValue }) => {
                                    const complementoDetallista = getFieldValue("complementoDetallista");
                                    if (!complementoDetallista) {
                                      return (
                                        <p style={{ textAlign: "center", margin: 0, color: "#999" }}>
                                          Active el Complemento Detallista para capturar la información requerida.
                                        </p>
                                      );
                                    }
                                    return (
                                      <>
                                        <Row gutter={16}>
                                          {/* ===================== CONFIGURACIÓN DOCUMENTO ===================== */}
                                          <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                            <DynamicCardForm title={ <span style={{ color: "#0098AD" }}>  Configuración Documento </span>}>
                                              <FormItem
                                                name="type"
                                                label="Type"
                                                margin
                                                labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                wrapperCol={{ span: 13 }}
                                              >
                                                <InputItem placeholder="Type" />
                                              </FormItem>
                                              <FormItem
                                                name="contentVersion"
                                                label="ContentVersion"
                                                margin
                                                labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                wrapperCol={{ span: 13 }}
                                              >
                                                <InputItem placeholder="ContentVersion" />
                                              </FormItem>
                                              <FormItem
                                                name="documentStrucutreVersion"
                                                label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>DocumentStrucutreVersion</span>}
                                                margin
                                                labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                wrapperCol={{ span: 13 }}
                                              >
                                                <InputItem placeholder="DocumentStrucutreVersion" />
                                              </FormItem>
                                              <FormItem
                                                name="documentStatus"
                                                label="DocumentStatus"
                                                margin
                                                labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                wrapperCol={{ span: 13 }}
                                                valuePropName="checked"
                                                tooltip="Se pondra la funcion del mensaje: ORIGINAL DELETE COPY REEMPLAZA"
                                              >
                                                <SwitchItem />
                                              </FormItem>
                                              <FormItem
                                                name="requestForPaymentIdentification"
                                                label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>RequestForPaymentIdentification</span>}
                                                margin
                                                labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                wrapperCol={{ span: 13 }}
                                                valuePropName="checked"
                                                tooltip="Se pondra el tipo de transaccion en entityType: INVOICE DEBIT_NOTE CREDIT_NOTE HONORARY_RECEIPT TRANSPORT_DOCUMENT"
                                              >
                                                <SwitchItem />
                                              </FormItem>
                                              <FormItem
                                                label="SpecialInstruction"
                                                margin
                                                name="specialInstruction"
                                                labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                wrapperCol={{ span: 13 }}
                                              >
                                                <SelectItem placeholder="SpecialInstruction">
                                                  <Option value={undefined}>Nada</Option>
                                                  <Option value="ZZZ">ZZZ - Importe con letra</Option>
                                                  <Option disabled value="AAB">AAB - Condiciones de pago</Option>
                                                  <Option disabled value="DUT">DUT - Informacion de impuestos (Pedimentos)</Option>
                                                  <Option disabled value="PUR">PUR - Informacion de compras</Option>
                                                </SelectItem>
                                              </FormItem>
                                            </DynamicCardForm>
                                          </Col>

                                          {/* ===================== REFERENCIAS ===================== */}
                                          <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                          <DynamicCardForm title={ <span style={{ color: "#0098AD" }}>  Referencias </span>}>
                                              <FormItem
                                                name="orderIdentification"
                                                label="OrderIdentification"
                                                margin
                                                labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                wrapperCol={{ span: 13 }}
                                                valuePropName="checked"
                                                tooltip="Se pondra el numero de pedido: ON - Orden de compra"
                                              >
                                                <SwitchItem
                                                  onChange={(value) =>
                                                    !value
                                                      ? this.formRef.current.setFieldsValue({
                                                        referenceDateOrderIdentification: false,
                                                      })
                                                      : null
                                                  }
                                                />
                                              </FormItem>
                                              <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  const orderIdentification = getFieldValue("orderIdentification");
                                                  return (
                                                    <FormItem
                                                      name="referenceDateOrderIdentification"
                                                      label="ReferenceDate"
                                                      margin
                                                      labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                      wrapperCol={{ span: 13 }}
                                                      valuePropName="checked"
                                                      tooltip="Se pedira la fecha de referencia"
                                                    >
                                                      <SwitchItem disabled={!orderIdentification} />
                                                    </FormItem>
                                                  );
                                                }}
                                              </FormItem>
                                              <FormItem
                                                name="additionalInformation"
                                                label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>AdditionalInformation</span>}
                                                margin
                                                labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                wrapperCol={{ span: 13 }}
                                                valuePropName="checked"
                                                tooltip="Se eligira la referencia adicional y el tipo"
                                              >
                                                <SwitchItem />
                                              </FormItem>
                                              <FormItem
                                                name="deliveryNote"
                                                label="DeliveryNote"
                                                margin
                                                labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                wrapperCol={{ span: 13 }}
                                                valuePropName="checked"
                                                tooltip="Se pedira el numero de folio"
                                              >
                                                <SwitchItem
                                                  onChange={(value) =>
                                                    !value
                                                      ? this.formRef.current.setFieldsValue({
                                                        referenceDateDeliveryNote: false,
                                                      })
                                                      : null
                                                  }
                                                />
                                              </FormItem>
                                              <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  const deliveryNote = getFieldValue("deliveryNote");
                                                  return (
                                                    <FormItem
                                                      name="referenceDateDeliveryNote"
                                                      label="ReferenceDate"
                                                      margin
                                                      labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                      wrapperCol={{ span: 13 }}
                                                      valuePropName="checked"
                                                      tooltip="Se pedira la fecha de referencia"
                                                    >
                                                      <SwitchItem disabled={!deliveryNote} />
                                                    </FormItem>
                                                  );
                                                }}
                                              </FormItem>
                                            </DynamicCardForm>
                                          </Col>
                                        </Row>

                                        <Row gutter={16}>
                                          {/* ===================== COMPRADOR (BUYER) ===================== */}
                                          <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                          <DynamicCardForm title={ <span style={{ color: "#0098AD" }}>  Comprador </span>}>

                                              {/* ── Switch buyer al inicio del body ── */}
                                              <FormItem
                                                name="buyer"
                                                label="Buyer"
                                                margin
                                                labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                wrapperCol={{ span: 13 }}
                                                valuePropName="checked"
                                                tooltip="Datos del comprador"
                                              >
                                                <SwitchItem
                                                  onChange={(value) =>
                                                    !value
                                                      ? this.formRef.current.setFieldsValue({
                                                        glnBuyer: undefined,
                                                        textBuyer: undefined,
                                                      })
                                                      : null
                                                  }
                                                />
                                              </FormItem>

                                              <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  const buyer = getFieldValue("buyer");
                                                  return (
                                                    <>
                                                      <FormItem
                                                        name="glnBuyer"
                                                        label="Gln"
                                                        margin
                                                        labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                        wrapperCol={{ span: 13 }}
                                                        tooltip="Codigo del comprador"
                                                      >
                                                        <InputItem disabled={!buyer} />
                                                      </FormItem>
                                                      <FormItem
                                                        name="textBuyer"
                                                        label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>PersonOrDepartmentName</span>}
                                                        margin
                                                        labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                        wrapperCol={{ span: 13 }}
                                                        tooltip="Contacto de compras"
                                                      >
                                                        <InputItem disabled={!buyer} />
                                                      </FormItem>
                                                    </>
                                                  );
                                                }}
                                              </FormItem>
                                            </DynamicCardForm>
                                          </Col>

                                          {/* ===================== PROVEEDOR (SELLER) ===================== */}
                                          <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                            <DynamicCardForm title={ <span style={{ color: "#0098AD" }}>  Proveedor </span>}>

                                              {/* ── Switch seller al inicio del body ── */}
                                              <FormItem
                                                name="seller"
                                                label="Seller"
                                                margin
                                                labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                wrapperCol={{ span: 13 }}
                                                valuePropName="checked"
                                                tooltip="Datos del proveedor"
                                              >
                                                <SwitchItem
                                                  onChange={(value) =>
                                                    !value
                                                      ? this.formRef.current.setFieldsValue({
                                                        glnSeller: undefined,
                                                        alternatePartyIdentificationType: undefined,
                                                        alternatePartyIdentification: undefined,
                                                      })
                                                      : null
                                                  }
                                                />
                                              </FormItem>

                                              <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  const seller = getFieldValue("seller");
                                                  return (
                                                    <>
                                                      <FormItem
                                                        name="glnSeller"
                                                        label="Gln"
                                                        margin
                                                        labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                        wrapperCol={{ span: 13 }}
                                                        tooltip="Codigo del proveedor"
                                                      >
                                                        <InputItem disabled={!seller} />
                                                      </FormItem>
                                                      <FormItem
                                                        label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>AlternatePartyIdentificationType</span>}
                                                        margin
                                                        name="alternatePartyIdentificationType"
                                                        labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                        wrapperCol={{ span: 13 }}
                                                      >
                                                        <SelectItem
                                                          placeholder="AlternatePartyIdentificationType"
                                                          disabled={!seller}
                                                        >
                                                          <Option value={undefined}>Nada</Option>
                                                          <Option value="SELLER_ASSIGNED_IDENTIFIER_FOR_A_PARTY">
                                                            SELLER_ASSIGNED_IDENTIFIER_FOR_A_PARTY - Número interno del proveedor
                                                          </Option>
                                                          <Option value="IEPS_REFERENCE">
                                                            IEPS_REFERENCE - Referencia signada para el IEPS
                                                          </Option>
                                                        </SelectItem>
                                                      </FormItem>
                                                      <FormItem
                                                        name="alternatePartyIdentification"
                                                        label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>AlternatePartyIdentification</span>}
                                                        margin
                                                        labelCol={{ lg: { span: 11 }, xl: { span: 11 }, xs: { span: 8 } }}
                                                        wrapperCol={{ span: 13 }}
                                                        tooltip="Identificacion secundaria del proveedor"
                                                      >
                                                        <InputItem disabled={!seller} />
                                                      </FormItem>
                                                    </>
                                                  );
                                                }}
                                              </FormItem>
                                            </DynamicCardForm>
                                          </Col>
                                        </Row>
                                      </>
                                    );
                                  }}
                                </FormItem>
                              </DynamicCardForm>
                            </Col>
                          </Row>
                        </>
                      ),
                    }] : []),
                  ...(this.props.insumosXCliente ? [{
                    key: '14',
                    label: 'Insumos',
                    forceRender: true,
                    customContent: (
                      <>
                        <FormItem
                          label="Activar Insumos x Cliente"
                          name="insumosXCliente"
                          margin
                          initialValue={false}
                          valuePropName="checked"
                          tooltip="Al activarlo, este cliente solo podrá comprar los insumos configurados aquí, y en sus ventas/pedidos/cotizaciones y PDFs verá el nombre alterno en vez del nombre interno."
                          labelCol={{ span: 6 }}
                          wrapperCol={{ span: 18 }}
                        >
                          <SwitchItem />
                        </FormItem>

                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const yaComparte = !!getFieldValue("insumosCompartidosDeClienteId");
                            // Si no comparte todavia, insumosPersonalizadosTotal es la cuenta de SUS
                            // propios insumos (la tabla de abajo aun no se resuelve contra otro cliente)
                            const tieneInsumosPropios = !yaComparte && this.state.insumosPersonalizadosTotal > 0;
                            return (
                              <FormItem
                                label="Usar la lista de otro cliente"
                                name="insumosCompartidosDeClienteId"
                                margin
                                hidden={!getFieldValue("insumosXCliente")}
                                tooltip='Si se elige un cliente aquí, este cliente deja de tener su propia lista: usa la de el, y cualquier insumo que agregues/edites/borres abajo se guarda en la lista de ese cliente. Solo se pueden elegir clientes con "Insumos x Cliente" activo que no estén a su vez usando la lista de otro.'
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 18 }}
                                extra={tieneInsumosPropios
                                  ? 'Este cliente ya tiene insumos propios configurados abajo; bórralos para poder usar la lista de otro cliente.'
                                  : yaComparte
                                    ? 'Guarda los cambios (botón "Guardar Cliente") para que este cliente empiece a usar esa lista.'
                                    : undefined}
                              >
                                <SelectClientesItem
                                  empresaId={this.props.empresaId}
                                  headersToken={this.props.headersToken}
                                  allowClear
                                  disabled={tieneInsumosPropios}
                                  placeholder={tieneInsumosPropios ? "Ya tiene insumos propios configurados" : "Usar la lista propia de este cliente"}
                                  soloDuenosInsumos
                                  excluirClienteId={this.state.id}
                                  onChange={(value) => {
                                    if (value) {
                                      message.info('Guarda los cambios (botón "Guardar Cliente") para que este cliente empiece a usar esa lista.');
                                    }
                                  }}
                                />
                              </FormItem>
                            );
                          }}
                        </FormItem>

                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            if (!getFieldValue("insumosXCliente")) {
                              return (
                                <p style={{ textAlign: "center", margin: 0, color: "#999" }}>
                                  Active "Insumos x Cliente" para configurar los insumos y nombres alternos de este cliente.
                                </p>
                              );
                            }
                            const clienteDuenoId = getFieldValue("insumosCompartidosDeClienteId");
                            return (
                              <>
                                {clienteDuenoId && (
                                  <Alert
                                    type="info"
                                    showIcon
                                    style={{ marginBottom: 10 }}
                                    message='Estos insumos son de la lista de otro cliente: lo que agregues, edites o borres aquí también se guarda ahí.'
                                  />
                                )}
                                <div style={{ display: "flex", justifyContent: "right", gap: 8, marginBottom: 10 }}>
                                  <ButtonItem
                                    icon={<TableOutlined />}
                                    cyan
                                    onClick={() => this.irACapturaInsumosCliente()}
                                  >
                                    Captura Rápida
                                  </ButtonItem>
                                  <ButtonItem
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => this.abrirModalInsumoPersonalizado()}
                                  >
                                    Agregar Insumo
                                  </ButtonItem>
                                </div>
                                <TableItemDinamico
                                  ref={(ref) => this.insumosPersonalizadosTableRef = ref}
                                  onRef={(ref) => this.insumosPersonalizadosTableRef = ref}
                                  size="small"
                                  loading={this.state.loadingInsumosPersonalizados}
                                  dataSource={this.state.insumosPersonalizadosData}
                                  totalRecords={this.state.insumosPersonalizadosTotal}
                                  onFetchData={this.consultarInsumosPersonalizados.bind(this)}
                                  columns={[
                                    { title: "Clave", dataIndex: "claveInterna", key: "claveInterna", buscar: "claveInterna", width: 90 },
                                    {
                                      title: "Insumo",
                                      dataIndex: "descripcion",
                                      key: "descripcion",
                                      buscar: "descripcion",
                                      render: (descripcion, record) => (
                                        <div>
                                          <div>{descripcion}</div>
                                          {record.equivalenciaClienteId && (
                                            <div style={{ fontSize: 11, color: "#bbb" }}>
                                              {record.equivalenciaClienteNombre || "Cliente"}
                                            </div>
                                          )}
                                        </div>
                                      ),
                                    },
                                    { title: "Nombre para el cliente", dataIndex: "nombreAlternativo", key: "nombreAlternativo", buscar: "nombreAlternativo" },
                                    { title: "Clave Cliente", dataIndex: "clave", key: "clave", buscar: "clave", width: 100 },
                                    { title: "Precio Unitario", dataIndex: "precio", key: "precio", width: 110, render: (value) => (value !== undefined && value !== null && value !== "" ? dineroDisabledMask(value) : "-") },
                                    { title: "Unidad", dataIndex: "unidadNombre", key: "unidadNombre", buscar: "unidadNombre", width: 120 },
                                    { title: "Presentación", dataIndex: "presentacion", key: "presentacion", buscar: "presentacion", width: 130 },
                                    { title: "Conversión", dataIndex: "conversion", key: "conversion", width: 100 },
                                    {
                                      title: "Acciones",
                                      dataIndex: "acciones",
                                      key: "acciones",
                                      width: 100,
                                      render: (_, record) => (
                                        <div className="acciones-container">
                                          <ButtonItem
                                            size="small"
                                            icon={<EditOutlined />}
                                            onClick={() => this.abrirModalInsumoPersonalizado(record)}
                                          />
                                          <Popconfirm
                                            title="¿Eliminar este insumo personalizado?"
                                            onConfirm={() => this.eliminarInsumoPersonalizado(record)}
                                            okText="Si"
                                            cancelText="No"
                                          >
                                            <ButtonItem size="small" danger icon={<DeleteOutlined />} />
                                          </Popconfirm>
                                        </div>
                                      ),
                                    },
                                  ]}
                                />
                              </>
                            );
                          }}
                        </FormItem>
                      </>
                    ),
                  }] : []),
                  ...(this.props.insumosXCliente ? [{
                    key: '15',
                    label: 'Subir Insumos',
                    forceRender: true,
                    customContent: (
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          if (!getFieldValue("insumosXCliente")) {
                            return (
                              <p style={{ textAlign: "center", margin: 0, color: "#999" }}>
                                Active "Insumos x Cliente" en la pestaña de Insumos para poder subir por Excel.
                              </p>
                            );
                          }
                          return (
                            <>
                              <div style={{ display: "flex", justifyContent: "right", marginBottom: 10 }}>
                                <ButtonItem
                                  icon={<TableOutlined />}
                                  onClick={() => this.irAEdicionMasivaInsumosCliente()}
                                  verde
                                >
                                  Edición Masiva
                                </ButtonItem>
                              </div>
                              <SeccionSubirInsumosCliente
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                loading={this.state.guardandoInsumosBulk}
                                insumosYaConfigurados={this.state.insumoIdsConfigurados}
                                onConfirmar={(filas, limpiar) => this.confirmarSubidaExcelInsumos(filas, limpiar)}
                              />
                            </>
                          );
                        }}
                      </FormItem>
                    ),
                  }] : []),
                  {
                    key: '9',
                    label: 'Complementos ',
                    forceRender: true,
                     customContent: (
                      <>
                      <Row gutter={16}>
                        <Col span={24}>
                          <DynamicCardForm title={<span>Complementos</span>}>                                       
                            {this.state.factorajeFinancieroCXC ? (
                         <FormItem
                          label="Activar Factoraje Financiero"
                          name="factorajeFinancieroCXC"
                          margin
                          valuePropName="checked"
                          tooltip="Al activar esta casilla se activa el factoraje financiero en este cliente."
                        >
                          <SwitchItem />
                        </FormItem>
                      ) : null}
                      {this.state.complementoComercioExterior ? (
                        <FormItem
                          label="Activar Complemento Comercio Exterior"
                          name="complementoComercioExterior"
                          margin
                          valuePropName="checked"
                          tooltip="Al activar esta casilla se activa el complemento de comercio exterior en este cliente."
                        >
                          <SwitchItem />
                        </FormItem>
                      ) : null}
                      <FormItem
                        label="Usar Leyendas Fiscales"
                        name="usarLeyendasFiscales"
                        margin
                        valuePropName="checked"
                        tooltip="Al activar esta casilla se agrega el complemento de Leyendas Fiscales al CFDI de las facturas de este cliente."
                      >
                        <SwitchItem />
                      </FormItem>
                      <FormItem
                        shouldUpdate={(prevValues, curValues) =>
                          prevValues.usarLeyendasFiscales !== curValues.usarLeyendasFiscales
                        }
                        noStyle
                      >
                        {({ getFieldValue }) =>
                          getFieldValue("usarLeyendasFiscales") ? (
                            <FormListLeyendasFiscales mostrarAviso />
                          ) : null
                        }
                      </FormItem>
                      <FormItem
                        label="Usar Adenda"
                        name="usarAdenda"
                        margin
                        valuePropName="checked"
                        tooltip="Al activar esta casilla podrás seleccionar y configurar la adenda requerida para el Comprobante Fiscal."
                      >
                        <SwitchItem 
                          onChange={(checked) => {
                            if(!checked) {
                              this.formRef.current.setFieldsValue({ adendaActiva: undefined });
                            }
                          }}
                        />
                      </FormItem>
                      <FormItem
                        shouldUpdate={(prevValues, curValues) =>
                          prevValues.usarAdenda !== curValues.usarAdenda || 
                          prevValues.adendaActiva !== curValues.adendaActiva
                        }
                        noStyle
                      >
                        {({ getFieldValue }) => {
                          const usaAdenda = getFieldValue("usarAdenda");
                          const adendaSeleccionada = getFieldValue("adendaActiva");

                          return usaAdenda ? (
                            <>
                              <FormItem
                                name="adendaActiva"
                                label="Selecciona la Adenda"
                                margin
                                rules={[{ required: true, message: "¡Falta activar la adenda!" }]}
                              >
                                  <SelectItem placeholder="Elige la adenda a utilizar">
                                    <Option value="Mabe">Mabe</Option>
                                    <Option value="Viscofan">Viscofan</Option>
                                    <Option value="Lesaffre">Lesaffre</Option>
                                    <Option value="Advans">Advans</Option>
                                    <Option value="Continental">Continental Tire</Option>
                                    <Option value="Goodyear">Goodyear</Option>
                                  </SelectItem>
                              </FormItem>

                              {adendaSeleccionada === "Mabe" && (
                                <>
                                  <FormItem
                                    name="referencia1"
                                    label="Referencia 1 (Mabe)"
                                    margin
                                    pattern
                                    rules={[
                                      {
                                        required: true,
                                        message: "La Referencia 1 es obligatoria para Mabe",
                                      },
                                    ]}
                                    tooltip="Ingrese el dato proporcionado para la referencia 1."
                                  >
                                    <InputItem placeholder="Referencia 1" />
                                  </FormItem>
                                  <FormItem
                                    name="referencia2"
                                    label="Referencia 2 (Mabe)"
                                    margin
                                    pattern
                                    tooltip="Ingrese el dato proporcionado para la referencia 2."
                                  >
                                    <InputItem placeholder="Referencia 2" />
                                  </FormItem>
                                  <FormItem
                                    name="usarUnidad"
                                    label="Usar unidad SAT del insumo"
                                    margin
                                    valuePropName="checked"
                                    tooltip="Si se activa esta casilla se usara la unidad de medida SAT del insumo, si no se activa se usara por defecto UN."
                                  >
                                    <SwitchItem />
                                  </FormItem>
                                </>
                              )}

                              {adendaSeleccionada === "Viscofan" && (
                                <>
                                  <FormItem
                                    name="viscofanCorreo"
                                    label="Correo Electrónico"
                                    margin
                                    required
                                    rules={[
                                      {
                                        type: "email",
                                        message: "El formato de correo no es válido",
                                      },
                                    ]}
                                    tooltip="Ingresa el correo electrónico para Viscofan."
                                  >
                                    <InputItem placeholder="correo@ejemplo.com" />
                                  </FormItem>
                                  <Alert
                                    message="Aviso Importante"
                                    description="Para la adenda Viscofan, asegúrate de haber llenado el campo *Código Proveedor* que se encuentra en la pestaña *General*."
                                    type="warning"
                                    showIcon
                                    style={{ marginBottom: '10px' }}
                                  />
                                </>
                              )}

                              {adendaSeleccionada === "Advans" && (
                                <>
                                  <FormItem
                                    name="advansLeyenda"
                                    label="Leyenda Operación"
                                    margin
                                    pattern
                                    required
                                    tooltip="Texto legal para el campo _8 de la adenda Advans (operación virtual / IMMEX)."
                                  >
                                    <TextAreaItem
                                      placeholder="Ej: Operación virtual conforme al art. 29 fracción I de la LIVA, arts. 105 y 112 de la Ley Aduanera y reglas 5.2.5, 5.2.6 y 4.3.21 de las RGCE vigentes. IMMEX <empresa>: <num> Embarcado A: <razón social> RFC <rfc>, <domicilio>"
                                      rows={5}
                                    />
                                  </FormItem>
                                  <FormItem
                                    name="advansReceptorCalle"
                                    label="Receptor Calle"
                                    margin
                                    pattern
                                    required
                                  >
                                    <InputItem placeholder="Ej: KEIZERSGRACHT 250" />
                                  </FormItem>
                                  <FormItem
                                    name="advansReceptorColonia"
                                    label="Receptor Colonia"
                                    margin
                                    pattern
                                    required
                                  >
                                    <InputItem placeholder="Ej: 1016 EV" />
                                  </FormItem>
                                  <FormItem
                                    name="advansReceptorLocalidad"
                                    label="Receptor Localidad"
                                    margin
                                    pattern
                                    required
                                  >
                                    <InputItem placeholder="Ej: AMSTERDAM, NETHERLANDS" />
                                  </FormItem>
                                  <FormItem
                                    name="advansReceptorMunicipio"
                                    label="Receptor Municipio"
                                    margin
                                    pattern
                                    required
                                  >
                                    <InputItem placeholder="Ej: AMSTERDAM, NETHERLANDS" />
                                  </FormItem>
                                  <FormItem
                                    name="advansReceptorEstado"
                                    label="Receptor Estado"
                                    margin
                                    pattern
                                    required
                                    tooltip="Código del estado/provincia según ISO (2 letras)"
                                  >
                                    <InputItem placeholder="Ej: NH" />
                                  </FormItem>
                                  <FormItem
                                    name="advansReceptorPais"
                                    label="Receptor País"
                                    margin
                                    pattern
                                    required
                                    tooltip="Código de país ISO 3 letras"
                                  >
                                    <InputItem placeholder="Ej: NLD" />
                                  </FormItem>
                                  <FormItem
                                    name="advansReceptorCodigoPostal"
                                    label="Receptor C.P."
                                    margin
                                    pattern
                                    required
                                  >
                                    <InputItem placeholder="Ej: 1016EV" />
                                  </FormItem>
                                </>
                              )}

                              {adendaSeleccionada === "Continental" && (
                                <>
                                  <FormItem
                                    name="continentalCodigoCompania"
                                    label="Código de Compañía"
                                    margin
                                    pattern
                                    required
                                    tooltip="Código de la compañía Continental que recibe la factura. Respeta los ceros a la izquierda."
                                  >
                                    <InputItem placeholder="Ej: 088" />
                                  </FormItem>
                                  <FormItem
                                    name="continentalTipoProv"
                                    label="Tipo de Proveedor"
                                    margin
                                    pattern
                                    required
                                    tooltip="Clave de tipo de proveedor asignada por Continental."
                                  >
                                    <InputItem placeholder="Ej: P" />
                                  </FormItem>
                                  <Alert
                                    message="Aviso Importante"
                                    description="Para la adenda Continental Tire, los datos que cambian en cada venta se capturan en la venta, no aquí: la Orden de Compra se manda como Pedido y Referencia_PO, y el campo Atención a se manda como Solicitante. Si la venta no trae Orden de Compra, la adenda se manda como PO = SIN."
                                    type="warning"
                                    showIcon
                                    style={{ marginBottom: '10px' }}
                                  />
                                </>
                              )}

                              {adendaSeleccionada === "Goodyear" && (
                                <Alert
                                  message="Aviso Importante"
                                  description="La adenda Goodyear no necesita datos del cliente: lo único que se manda es la Orden de Compra, y ésa se captura en cada venta en el campo *O Compra*. Sin Orden de Compra la factura no se timbra."
                                  type="warning"
                                  showIcon
                                  style={{ marginBottom: '10px' }}
                                />
                              )}

                            </>
                          ) : null;
                        }}
                      </FormItem>
                          </DynamicCardForm>
                        </Col>
                      </Row>
                      </>
                    ),
                  },
                  {
                    key: '10',
                    label: 'Archivos',
                    customContent: (
                      <>
                  <Row gutter={16}>
                    <Col span={24}>
                      <DynamicCardForm title={<span>Archivos del Cliente</span>}>
                          <FormItem
                              name="archivos"
                              margin
                              style={{display: "block", justifyContent: "flex-start", alignItems: "initial",textAlign: "left",
                              }}
                            >
                            <Upload
                              showUploadList={{
                                showRemoveIcon: true,
                                showPreviewIcon: true,
                                removeIcon: (file) => (
                                  <Popconfirm
                                    title="¿Seguro que quieres eliminar el archivo?"
                                    onConfirm={() => {
                                      this.onRemoveFile(file);
                                    }}
                                    okText="Si"
                                    cancelText="No"
                                  >
                                    <DeleteOutlined
                                      onClick={(e) => e.preventDefault()}
                                    />
                                  </Popconfirm>
                                ),
                              }}
                              fileList={this.state.archivosCliente}
                              customRequest={this.customRequestArchivos.bind(this)}
                              multiple={true}
                              onPreview={this.handlePreview}
                              beforeUpload={this.beforeUploadArchivos}
                            >
                              <ButtonItem
                                icon={<UploadOutlined />}
                                cyan
                                disabled={this.state.archivosCliente.length >= this.state.maximoArchivos}
                              >
                                Agregar archivos
                              </ButtonItem>
                            </Upload>
                        </FormItem>
                      </DynamicCardForm>
                    </Col>
                  </Row>
                      </>
                    ),
                  },
                  ...(this.state.complementoEmpresaAlterna
                    ? [{
                        key: '16',
                        label: 'Empresa Alterna',
                        forceRender: true,
                        customContent: (
                          <>
                            <Row gutter={16}>
                              <Col span={24}>
                                <DynamicCardForm title={<span>Empresa Alterna en Documentos</span>}>
                                  <Alert
                                    message="Empresa Alterna"
                                    description="Estos datos sustituirán a los de tu empresa en Remisión, Cotización y Pedido para este cliente. No afecta la Factura."
                                    type="info"
                                    showIcon
                                    style={{ marginBottom: 16 }}
                                  />
                                  <FormItem
                                    name={["empresaAlterna", "activo"]}
                                    label="Activar Empresa Alterna"
                                    margin
                                    valuePropName="checked"
                                  >
                                    <SwitchItem />
                                  </FormItem>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      const activo = getFieldValue(["empresaAlterna", "activo"]);
                                      if (!activo) return null;
                                      const persona = getFieldValue(["empresaAlterna", "persona"]);
                                      return (
                                        <>
                                          <Row gutter={16}>
                                            <Col xs={24} md={12}>
                                              <FormItem
                                                name={["empresaAlterna", "nombre"]}
                                                label="Nombre / Razón Social"
                                                margin
                                                pattern
                                                required
                                              >
                                                <InputItem placeholder="Nombre / Razón Social" />
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={12}>
                                              <FormItem
                                                name={["empresaAlterna", "persona"]}
                                                label="Persona Moral"
                                                margin
                                                valuePropName="checked"
                                              >
                                                <Checkbox />
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          {!persona ? (
                                            <Row gutter={16}>
                                              <Col xs={24} md={12}>
                                                <FormItem name={["empresaAlterna", "apellidoPaterno"]} label="Apellido Paterno" margin pattern>
                                                  <InputItem placeholder="Apellido Paterno" />
                                                </FormItem>
                                              </Col>
                                              <Col xs={24} md={12}>
                                                <FormItem name={["empresaAlterna", "apellidoMaterno"]} label="Apellido Materno" margin pattern>
                                                  <InputItem placeholder="Apellido Materno" />
                                                </FormItem>
                                              </Col>
                                            </Row>
                                          ) : null}
                                          <Row gutter={16}>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "nombreComercial"]} label="Nombre Comercial" margin pattern>
                                                <InputItem placeholder="Nombre Comercial" />
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "rfc"]} label="RFC" margin pattern required>
                                                <InputItem placeholder="RFC" />
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          <Row gutter={16}>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "correo"]} label="Correo" margin pattern email>
                                                <InputItem placeholder="correo@ejemplo.com" />
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "telefono"]} label="Teléfono" margin number>
                                                <InputNumberItem placeholder="Teléfono" celular />
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          <Row gutter={16}>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "paisId"]} label="País" margin required>
                                                <SelectItem placeholder="País">
                                                  {this.state.objetoPaises}
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "estadoId"]} label="Estado" margin required>
                                                <SelectItem placeholder="Estado" onChange={this.onChangeEstadoAlterna.bind(this)}>
                                                  {this.state.objetoEstados}
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          <Row gutter={16}>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "municipioId"]} label="Municipio" margin required>
                                                <SelectItem placeholder="Municipio" onChange={this.onChangeMunicipioAlterna.bind(this)}>
                                                  {this.state.objetoMunicipiosAlterna === null ? (
                                                    <Option disabled>Elija primero un estado</Option>
                                                  ) : (
                                                    this.state.objetoMunicipiosAlterna
                                                  )}
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={12}>
                                              <FormItem name={["empresaAlterna", "coloniaId"]} label="Colonia" margin required>
                                                <SelectItem placeholder="Colonia">
                                                  {this.state.objetoColoniasAlterna === null ? (
                                                    <Option disabled>Elija primero un municipio</Option>
                                                  ) : (
                                                    this.state.objetoColoniasAlterna
                                                  )}
                                                </SelectItem>
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          <Row gutter={16}>
                                            <Col xs={24} md={8}>
                                              <FormItem name={["empresaAlterna", "calle"]} label="Calle" margin pattern>
                                                <InputItem placeholder="Calle" />
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={8}>
                                              <FormItem name={["empresaAlterna", "numeroCalle"]} label="Número Exterior" margin>
                                                <InputItem placeholder="Número Exterior" />
                                              </FormItem>
                                            </Col>
                                            <Col xs={24} md={8}>
                                              <FormItem name={["empresaAlterna", "numeroInterior"]} label="Número Interior" margin pattern>
                                                <InputItem placeholder="Número Interior" />
                                              </FormItem>
                                            </Col>
                                          </Row>
                                          <FormItem label="Logo">
                                            <Upload
                                              accept="image/*"
                                              showUploadList={false}
                                              customRequest={this.onChangeArchivoLogoAlterna.bind(this)}
                                            >
                                              <ButtonItem blanco icon={<UploadOutlined />}>Subir logo</ButtonItem>
                                            </Upload>
                                            {this.state.base64LogoAlterna ? (
                                              <img
                                                src={this.state.base64LogoAlterna}
                                                alt="Logo Empresa Alterna"
                                                style={{ maxHeight: 80, marginLeft: 16, verticalAlign: "middle" }}
                                              />
                                            ) : null}
                                          </FormItem>
                                        </>
                                      );
                                    }}
                                  </FormItem>
                                </DynamicCardForm>
                              </Col>
                            </Row>
                          </>
                        )
                      }]
                    : []),
                  {
                    key: '11',
                    label: 'Cuentas Cliente',
                    forceRender: true,
                    customContent: (
                      <>
                        <Row gutter={16}>
                          <Col span={24}>
                            <DynamicCardForm
                              title={
                                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                Cuentas de Pago del Cliente
                                </span>
                              }
                              headerRight={
                                <span style={{ color: '#00BFD6', fontSize: 11 }}>
                                  Complemento de Pago
                                </span>
                              }
                            >
                              {/* Alerta informativa */}
                              <Alert
                                 message="Cuentas de Pago del Cliente"
                                description="Estas son las cuentas que el cliente utiliza para realizar sus pagos. Serán utilizadas para la completar los datos del Complemento de Pago. Marca una con la estrella para que sea la que se proponga por default al cobrar una venta."
                                type="info"
                                showIcon
                                style={{
                                  marginBottom: 20, borderRadius: 6, border: '1px solid #b8e8f0',
                                  background: 'linear-gradient(135deg, #f0fbfd 0%, #e6f7fa 100%)',
                                  fontSize: 13,
                                }}
                              />

                              <FormInitial.List name="cuentasBancoCliente">
                                {(fields, { add, remove }) => (
                                  <>
                                    {/* Encabezados de columna */}
                                    {fields.length > 0 && (
                                      <Row
                                        gutter={16}
                                        style={{
                                          marginBottom: 6,
                                          padding: '6px 12px',
                                          background: `
                                            linear-gradient(135deg, #00BFD6 0%, #0098AD 100%)bottom / 100% 4px no-repeat,
                                            #fff
                                          `,
                                          borderRadius: 3,
                                        }}
                                      >
                                        <Col span={6}>
                                          <span style={{ fontWeight: 700, fontSize: 11, color: '#0098AD', letterSpacing: '0.6px', textTransform: 'uppercase' }}>
                                            DESCRIPCIÓN
                                          </span>
                                        </Col>
                                        <Col span={7}>
                                          <span style={{ fontWeight: 700, fontSize: 11, color: '#0098AD', letterSpacing: '0.6px', textTransform: 'uppercase' }}>
                                            BANCO (SAT)
                                          </span>
                                        </Col>
                                        <Col span={7}>
                                          <span style={{ fontWeight: 700, fontSize: 11, color: '#0098AD', letterSpacing: '0.6px', textTransform: 'uppercase' }}>
                                            CUENTA / CLABE
                                          </span>
                                        </Col>
                                        <Col span={2} style={{ textAlign: 'center' }}>
                                          <span style={{ fontWeight: 700, fontSize: 11, color: '#0098AD', letterSpacing: '0.6px', textTransform: 'uppercase' }}>
                                            PRED.
                                          </span>
                                        </Col>
                                        <Col span={2} />
                                      </Row>
                                    )}

                                    {/* Filas de cuentas */}
                                    {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                                      <Row
                                        key={key}
                                        gutter={16}
                                        align="middle"
                                        style={{
                                          padding: '8px 12px', marginBottom: 4, borderRadius: 6,
                                          background: index % 2 === 0 ? '#ffffff' : '#f7fcfd', border: '1px solid #e8f7fa',
                                          transition: 'box-shadow 0.2s ease',
                                        }}
                                      >
                                        <Col span={6}>
                                          <FormItem
                                            {...restField}
                                            name={[name, "descripcion"]}
                                            fieldKey={[fieldKey, "descripcion"]}
                                            margin
                                          >
                                            <InputItem placeholder="Ej. BBVA Dólares" />
                                          </FormItem>
                                        </Col>

                                        <Col span={7}>
                                          <FormItem
                                            {...restField}
                                            name={[name, "bancoSatId"]}
                                            fieldKey={[fieldKey, "bancoSatId"]}
                                            required
                                            margin
                                          >
                                            <SelectItem placeholder="Seleccionar Banco">
                                              {this.state.objetoBancosSat}
                                            </SelectItem>
                                          </FormItem>
                                        </Col>

                                        <Col span={7}>
                                          <FormItem
                                            {...restField}
                                            name={[name, "cuenta"]}
                                            fieldKey={[fieldKey, "cuenta"]}
                                            required
                                            margin
                                            pattern
                                          >
                                            <InputItem placeholder="10, 11 o 18 dígitos" />
                                          </FormItem>
                                        </Col>

                                        <Col span={2} style={{ textAlign: 'center' }}>
                                          {/* El valor vive en el formulario; la estrella solo lo refleja */}
                                          <FormItem
                                            {...restField}
                                            name={[name, "predeterminada"]}
                                            fieldKey={[fieldKey, "predeterminada"]}
                                            hidden
                                            valuePropName="checked"
                                          >
                                            <Checkbox />
                                          </FormItem>
                                          <FormItem noStyle shouldUpdate>
                                            {({ getFieldValue }) => {
                                              const esPredeterminada = !!getFieldValue([
                                                "cuentasBancoCliente",
                                                name,
                                                "predeterminada",
                                              ]);
                                              return (
                                                <ButtonItem
                                                  type="text"
                                                  lessTime
                                                  style={{ backgroundColor: '#ffff' }}
                                                  title={
                                                    esPredeterminada
                                                      ? "Cuenta predeterminada, click para quitarla"
                                                      : "Marcar como cuenta predeterminada"
                                                  }
                                                  onClick={() => this.marcarCuentaPredeterminada(name)}
                                                  icon={
                                                    esPredeterminada ? (
                                                      <StarFilled style={{ color: '#FFC107' }} />
                                                    ) : (
                                                      <StarOutlined style={{ color: '#ffffff' }} />
                                                    )
                                                  }
                                                />
                                              );
                                            }}
                                          </FormItem>
                                        </Col>

                                        <Col span={2} style={{ textAlign: 'center' }}>
                                          <Popconfirm
                                            title="¿Eliminar esta cuenta?"
                                            onConfirm={() => remove(name)}
                                            okText="Sí"
                                            cancelText="No"
                                            placement="left"
                                          >
                                            <ButtonItem
                                              type="text"
                                              danger                          
                                              rojo
                                              style={{
                                                backgroundColor: '#ffff'
                                              }}
                                              icon={<DeleteOutlined />}
                                              lessTime
                                                                
                                            />
                                          </Popconfirm>
                                        </Col>
                                      </Row>
                                    ))}

                                    {/* Botón agregar */}
                                    <div style={{ marginTop: fields.length > 0 ? 16 : 4, textAlign: 'center' }}>
                                      <ButtonItem
                                        type="dashed"
                                        onClick={() => add()}
                                        icon={<PlusOutlined />}
                                        cyan
                                        style={{
                                          width: 280,
                                          borderRadius: 8,
                                          fontSize: 13,
                                          fontWeight: 600,
                                        }}
                                      >
                                        Agregar Nueva Cuenta Bancaria
                                      </ButtonItem>
                                    </div>
                                  </>
                                )}
                              </FormInitial.List>
                            </DynamicCardForm>
                          </Col>
                        </Row>
                      </>
                    ),
                  },
                  ...(this.props.escuela
                    ? [
                        {
                          key: '12',
                          label: 'Escuela',
                          forceRender: true,
                          customContent: (
                            <>
                              <Row gutter={16}>
                                <Col span={24}>
                                  <DynamicCardForm title={<span>Datos del Alumno</span>}>
                                    {this.state.dataInicial?.datosAlumno?.escuelaId ? (
                                      <>
                                        <FormItem
                                          label="Escuela"
                                          name={["datosAlumno", "escuelaId"]}
                                          margin
                                        >
                                          <SelectEscuelasItem
                                            placeholder="Selecciona una escuela"
                                            empresaId={this.props.empresaId}
                                            headersToken={this.props.headersToken}
                                          />
                                        </FormItem>
                                        <FormItem
                                          noStyle
                                          shouldUpdate={(prev, curr) =>
                                            prev?.datosAlumno?.escuelaId !==
                                            curr?.datosAlumno?.escuelaId
                                          }
                                        >
                                          {({ getFieldValue }) => (
                                            <FormItem
                                              label="Grupo"
                                              name={["datosAlumno", "grupoEscuelaId"]}
                                              margin
                                            >
                                              <SelectGruposEscuelaItem
                                                placeholder="Selecciona un grupo"
                                                empresaId={this.props.empresaId}
                                                headersToken={this.props.headersToken}
                                                escuelaId={getFieldValue([
                                                  "datosAlumno",
                                                  "escuelaId",
                                                ])}
                                                allowClear
                                              />
                                            </FormItem>
                                          )}
                                        </FormItem>
                                        <FormItem
                                          label="Lista Individual"
                                          name={["datosAlumno", "listaId"]}
                                          margin
                                          tooltip={{
                                            title:
                                              "Lista adicional asignada al alumno, aparte de la que tenga su grupo.",
                                          }}
                                        >
                                          <SelectListasEscuelaItem
                                            placeholder="Selecciona una lista individual"
                                            empresaId={this.props.empresaId}
                                            headersToken={this.props.headersToken}
                                            allowClear
                                          />
                                        </FormItem>
                                        <FormItem
                                          label="Matrícula"
                                          name={["datosAlumno", "matricula"]}
                                          max={50}
                                          margin
                                        >
                                          <InputItem placeholder="Ej: A01234567" />
                                        </FormItem>
                                        <FormItem
                                          label="Nivel Prepa"
                                          name={["datosAlumno", "nivelPrepare"]}
                                          max={50}
                                          margin
                                        >
                                          <InputItem placeholder="Nivel Prepa" />
                                        </FormItem>
                                        <FormItem
                                          label="Nivel Inglés"
                                          name={["datosAlumno", "nivelIngles"]}
                                          margin
                                        >
                                          <InputNumberItem
                                            placeholder="0-10"
                                            min={0}
                                            max={10}
                                            step={0.1}
                                          />
                                        </FormItem>

                                        {/* Hermanos vinculados */}
                                        <div style={{ marginTop: 16 }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              marginBottom: 8,
                                            }}
                                          >
                                            <span style={{ fontWeight: 600 }}>
                                              Hermanos vinculados
                                            </span>
                                            <ButtonItem
                                              icon={<PlusOutlined />}
                                              onClick={() =>
                                                this.setState({
                                                  modalHermano: true,
                                                })
                                              }
                                            >
                                              Agregar hermano
                                            </ButtonItem>
                                          </div>
                                          {(
                                            this.state.dataInicial
                                              ?.hermanosVinculadosData || []
                                          ).length === 0 ? (
                                            <Alert
                                              type="info"
                                              showIcon
                                              message="Sin hermanos vinculados"
                                            />
                                          ) : (
                                            (
                                              this.state.dataInicial
                                                .hermanosVinculadosData
                                            ).map((h) => (
                                              <div
                                                key={h.clienteId}
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "space-between",
                                                  alignItems: "center",
                                                  border: "1px solid #f0f0f0",
                                                  borderRadius: 6,
                                                  padding: "6px 12px",
                                                  marginBottom: 6,
                                                }}
                                              >
                                                <div>
                                                  <div>
                                                    {h.nombre || "Alumno"}
                                                  </div>
                                                  <div
                                                    style={{
                                                      fontSize: 12,
                                                      color: "#999",
                                                    }}
                                                  >
                                                    {h.matricula
                                                      ? `Matrícula: ${h.matricula}`
                                                      : "—"}
                                                  </div>
                                                </div>
                                                <Popconfirm
                                                  title="¿Quitar este hermano?"
                                                  okText="Quitar"
                                                  cancelText="Cancelar"
                                                  onConfirm={() =>
                                                    this.quitarHermano(
                                                      h.clienteId
                                                    )
                                                  }
                                                >
                                                  <ButtonItem
                                                    danger
                                                    icon={<DeleteOutlined />}
                                                    lessTime
                                                  >
                                                    Quitar
                                                  </ButtonItem>
                                                </Popconfirm>
                                              </div>
                                            ))
                                          )}
                                        </div>
                                      </>
                                    ) : (
                                      <Alert
                                        type="info"
                                        showIcon
                                        message="Este cliente no fue creado como alumno"
                                        description="Para gestionar datos de escuela, los alumnos deben crearse desde la pestaña Alumnos del módulo Escuela."
                                      />
                                    )}
                                  </DynamicCardForm>
                                </Col>
                              </Row>
                            </>
                          ),
                        },
                      ]
                    : []),
                  {
                    key: '13',
                    label: 'Historial',
                    forceRender: true,
                    customContent: (
                      <Spin spinning={this.state.loadingHistorial}>
                        <Row gutter={16}>
                          <Col span={24}>
                            {this.renderHistorialSeccion(
                              "Ventas",
                              this.state.historialVentas,
                              [
                                {
                                  title: "Tipo",
                                  key: "tipo",
                                  render: (_, row) =>
                                    row.factura
                                      ? "Factura"
                                      : row.remision
                                        ? "Remisión"
                                        : row.facturaGlobalNumero
                                          ? "Factura Global"
                                          : "-",
                                },
                                {
                                  title: "Número",
                                  key: "numero",
                                  render: (_, row) =>
                                    (row.factura
                                      ? `${row.facturaSerie || ""} ${row.facturaNumero || ""}`
                                      : row.remision
                                        ? `${row.remisionSerie || ""} ${row.remisionNumero || ""}`
                                        : row.facturaGlobalNumero
                                          ? `${row.facturaGlobalSerie || ""} ${row.facturaGlobalNumero || ""}`
                                          : ""
                                    ).trim() || "-",
                                },
                                {
                                  title: "Fecha",
                                  key: "fecha",
                                  render: (_, row) => {
                                    const fecha = row.fechaFactura || row.fechaRemision;
                                    return fecha ? moment(fecha).format("DD/MM/YYYY") : "-";
                                  },
                                },
                                {
                                  title: "Total",
                                  dataIndex: "totalPagar",
                                  key: "totalPagar",
                                  align: "right",
                                  render: (v) => dineroDisabledMask(v || 0),
                                },
                                {
                                  title: "Acciones",
                                  key: "acciones",
                                  align: "center",
                                  render: (_, row) => (
                                    <ButtonItem
                                      icon={<FilePdfOutlined />}
                                      loading={this.state.pdfGenerandoId === row._id}
                                      onClick={() => this.verPdfVenta(row._id)}
                                    >
                                      Ver PDF
                                    </ButtonItem>
                                  ),
                                },
                              ]
                            )}
                          </Col>
                          <Col span={24} style={{ marginTop: 16 }}>
                            {this.renderHistorialSeccion(
                              "Pedidos",
                              this.state.historialPedidos,
                              [
                                {
                                  title: "Número",
                                  key: "numero",
                                  render: (_, row) =>
                                    `${row.pedidoSerie || ""} ${row.pedidoNumero || ""}`.trim() || "-",
                                },
                                {
                                  title: "Fecha",
                                  key: "fecha",
                                  render: (_, row) =>
                                    row.fechaPedido ? moment(row.fechaPedido).format("DD/MM/YYYY") : "-",
                                },
                                {
                                  title: "Total",
                                  dataIndex: "totalPagar",
                                  key: "totalPagar",
                                  align: "right",
                                  render: (v) => dineroDisabledMask(v || 0),
                                },
                                {
                                  title: "Acciones",
                                  key: "acciones",
                                  align: "center",
                                  render: (_, row) => (
                                    <ButtonItem
                                      icon={<FilePdfOutlined />}
                                      loading={this.state.pdfGenerandoId === row._id}
                                      onClick={() => this.verPdfPedido(row._id)}
                                    >
                                      Ver PDF
                                    </ButtonItem>
                                  ),
                                },
                              ]
                            )}
                          </Col>
                          <Col span={24} style={{ marginTop: 16 }}>
                            {this.renderHistorialSeccion(
                              "Cotizaciones",
                              this.state.historialCotizaciones,
                              [
                                {
                                  title: "Número",
                                  key: "numero",
                                  render: (_, row) =>
                                    `${row.cotizacionSerie || ""} ${row.cotizacionNumero || ""}`.trim() || "-",
                                },
                                {
                                  title: "Fecha",
                                  key: "fecha",
                                  render: (_, row) =>
                                    row.fechaCotizacion ? moment(row.fechaCotizacion).format("DD/MM/YYYY") : "-",
                                },
                                {
                                  title: "Total",
                                  dataIndex: "totalPagar",
                                  key: "totalPagar",
                                  align: "right",
                                  render: (v) => dineroDisabledMask(v || 0),
                                },
                                {
                                  title: "Acciones",
                                  key: "acciones",
                                  align: "center",
                                  render: (_, row) => (
                                    <ButtonItem
                                      icon={<FilePdfOutlined />}
                                      loading={this.state.pdfGenerandoId === row._id}
                                      onClick={() => this.verPdfCotizacion(row._id)}
                                    >
                                      Ver PDF
                                    </ButtonItem>
                                  ),
                                },
                              ]
                            )}
                          </Col>
                          {this.props.taxidermia && (
                            <Col span={24} style={{ marginTop: 16 }}>
                              {this.renderHistorialSeccion(
                                "Animales",
                                this.state.historialLotes,
                                [
                                  {
                                    title: "Lote/Número",
                                    key: "numero",
                                    render: (_, row) => row.lote || row.numero || "-",
                                  },
                                  {
                                    title: "Especie",
                                    dataIndex: "tipoEspecie",
                                    key: "tipoEspecie",
                                    render: (v) => v || "-",
                                  },
                                  {
                                    title: "Insumo",
                                    key: "insumo",
                                    render: (_, row) => row.insumoId?.nombre || "-",
                                  },
                                  {
                                    title: "Fecha Ingreso",
                                    key: "fecha",
                                    render: (_, row) => {
                                      const fecha = row.fechaIngresoM || row.fechaEntrega;
                                      return fecha ? moment(fecha).format("DD/MM/YYYY") : "-";
                                    },
                                  },
                                  {
                                    title: "Acciones",
                                    key: "acciones",
                                    align: "center",
                                    render: (_, row) => (
                                      <ButtonItem
                                        icon={<EyeOutlined />}
                                        onClick={() => this.abrirLote(row._id)}
                                      >
                                        Ver
                                      </ButtonItem>
                                    ),
                                  },
                                ]
                              )}
                            </Col>
                          )}
                        </Row>
                      </Spin>
                    ),
                  },
                ]}
              />
            </Form>
          </Spin>
        </div>
        <ModalUsuarioMovil
          visible={this.state.modalUsuarioMovil}
          onCancel={() => this.setState({ modalUsuarioMovil: false })}
          onSuccess={() => this.setState({ modalUsuarioMovil: false })}
          tipo="CLIENTE"
          referenciaId={this.state.id}
          nombreSugerido={this.formRef.current?.getFieldValue("nombre")}
          correoSugerido={this.formRef.current?.getFieldValue("correo")}
        />
        <AgregarUnidad
          visible={this.state.modalAgregarUnidad}
          cerrarAgregarUnidad={this.cerrarAgregarUnidad.bind(this)}
        />
        <ModalPrevisualizarArchivos
          file={currentPreviewFile}
          clienteId={this.state.id}
          visible={filePreviewVisible}
          onClose={this.handleCloseFilePreview}
        />
        <UsuarioEcommerceModal
          visible={this.state.modalUsuarioEcommerceVisible}
          clienteId={this.state.id}
          cliente={this.state.dataInicial}
          cerrarModal={() =>
            this.setState({ modalUsuarioEcommerceVisible: false })
          }
        />
        <ModalAgregarHermano
          visible={this.state.modalHermano}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          escuelaId={this.state.dataInicial?.datosAlumno?.escuelaId}
          clienteId={this.state.id}
          onCancel={() => this.setState({ modalHermano: false })}
          onSuccess={async () => {
            this.setState({ modalHermano: false });
            await this.recargarHermanos();
          }}
        />
        <VerLote
          visible={this.state.modalVerLote}
          cerrarVerLote={this.cerrarVerLote.bind(this)}
          loteId={this.state.modalVerLoteId}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <ModalInsumoParaCliente
          visible={this.state.modalInsumoPersonalizadoVisible}
          item={this.state.insumoPersonalizadoEditando}
          loading={this.state.guardandoInsumoPersonalizado}
          insumosYaConfigurados={this.state.insumoIdsConfigurados}
          onCancel={() => this.cerrarModalInsumoPersonalizado()}
          onGuardar={(valores) => this.guardarInsumoPersonalizado(valores)}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
        />
        <CambiarTipoEntidadModal
          visible={this.state.modalCambiarTipo}
          entidad="cliente"
          entidadId={this.state.id}
          nombre={this.state.dataInicial?.persona
            ? this.state.dataInicial?.razonSocial
            : [
                this.state.dataInicial?.nombre,
                this.state.dataInicial?.apellidoPaterno,
                this.state.dataInicial?.apellidoMaterno,
              ]
                .filter(Boolean)
                .join(" ")}
          tipos={this.state.todasTipoDeCliente}
          tipoActualId={this.state.dataInicial?.tipoClienteId}
          onCerrar={(huboCambio, resultado) => {
            this.setState({
              modalCambiarTipo: false,
              polizaReclasificacionId: resultado?.polizaId || null,
            });
            // El tipo cambia cuentas contables y puede generar subcuentas nuevas:
            // se recarga todo para que el formulario no quede con datos viejos.
            if (huboCambio) this.consultarTodo();
          }}
        />
        <MoverCuentasEntidadModal
          visible={this.state.modalMoverCuentas}
          entidad="cliente"
          entidadId={this.state.id}
          nombre={this.state.dataInicial?.persona
            ? this.state.dataInicial?.razonSocial
            : [
                this.state.dataInicial?.nombre,
                this.state.dataInicial?.apellidoPaterno,
                this.state.dataInicial?.apellidoMaterno,
              ]
                .filter(Boolean)
                .join(" ")}
          cuentasContables={this.state.todasCuentaContable}
          onCerrar={(huboCambio, resultado) => {
            this.setState({
              modalMoverCuentas: false,
              polizaReclasificacionId: resultado?.polizaId || null,
            });
            // Las cuentas del formulario se leen del cliente: hay que recargarlo.
            if (huboCambio) this.consultarTodo();
          }}
        />
        <ModalEditarPoliza
          visible={!!this.state.polizaReclasificacionId}
          polizaId={this.state.polizaReclasificacionId}
          onCancel={() => this.setState({ polizaReclasificacionId: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    complementoDetallista: state.empresa.complementoDetallista,
    insumosXCliente: state.empresa.insumosXCliente,
    fletes: state.empresa.fletes,
    escuela: state.empresa.escuela,
    appMovil: state.empresa.appMovil,
    ventaOnline: state.empresa.ventaOnline,
    taxidermia: state.empresa.taxidermia,
    permisoModificarParametosDeCredito:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6999ecf0153232381f120f72",
      )?.activado,
    permisoControlUsuarioMovil:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a1092812a586012f03f5fbf",
      )?.activado,
    permisoCrearUsuariosEcommerce:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a108fa32a586012f03f5aa9",
      )?.activado,
  };
};

export default connect(mapStateToProps)(EditarCliente);
